/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _VideoCollectionsService = __webpack_require__(95);
	
	var _VideoCollectionsService2 = _interopRequireDefault(_VideoCollectionsService);
	
	var _VideoCollection = __webpack_require__(96);
	
	var _VideoCollection2 = _interopRequireDefault(_VideoCollection);
	
	var _VideoShowCollection = __webpack_require__(105);
	
	var _VideoShowCollection2 = _interopRequireDefault(_VideoShowCollection);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoCollections = function (_React$Component) {
		_inherits(VideoCollections, _React$Component);
	
		function VideoCollections(props) {
			_classCallCheck(this, VideoCollections);
	
			var _this = _possibleConstructorReturn(this, (VideoCollections.__proto__ || Object.getPrototypeOf(VideoCollections)).call(this, props));
	
			_this.state = {
				collections: []
			};
			return _this;
		}
	
		_createClass(VideoCollections, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var postId = (0, _utils.getPostId)();
	
				_VideoCollectionsService2.default.getCollections(postId).then(function (collections) {
					_this2.setState(function () {
						return {
							collections: collections
						};
					});
					//render nav after collecitons are rendered
					var colNav = document.querySelector('.anchor-nav-wrapper');
					if (colNav) {
						colNav.style.visibility = 'visible';
					}
				});
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {}
		}, {
			key: 'render',
			value: function render() {
				var collections = this.state.collections;
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: 'anchor-container' },
					collections.length ? collections.map(function (c, index) {
						var idx = 1 + index++;
						var collectionId = 'collection-' + idx;
						if (c.isShow) {
							return _react2.default.createElement(_VideoShowCollection2.default, { collection: c, key: key++, id: collectionId, index: idx });
						} else {
							return _react2.default.createElement(_VideoCollection2.default, { collection: c, key: key++, id: collectionId, index: idx });
						}
					}) : _react2.default.createElement('div', null)
				);
			}
		}]);
	
		return VideoCollections;
	}(_react2.default.Component);
	
	var mountNodes = document.getElementsByTagName('VideoCollections');
	if (mountNodes.length > 0) {
		_reactDom2.default.render(_react2.default.createElement(VideoCollections, null), mountNodes[0]);
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = ReactDOM;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(4);
	
	var _FetchService = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FsPlaylistService = function () {
		function FsPlaylistService() {
			_classCallCheck(this, FsPlaylistService);
	
			this.MpxPlaylist = null;
			this.parselyPlaylist = null;
		}
	
		_createClass(FsPlaylistService, [{
			key: 'getMpxPlaylist',
			value: function getMpxPlaylist(endcard, limit, postId) {
				if (this.MpxPlaylist) {
					return this.MpxPlaylist;
				}
				this.MpxPlaylist = (0, _FetchService.get)(_constants.settings.MPX_PLAYLIST_URL + '?mpxfeed=' + encodeURIComponent(endcard) + '&limit=' + limit + '&postId=' + postId, function (json) {
					var data = json.data;
					return Array.isArray(data) ? data : [data];
				}, function () {
					return [];
				});
				return this.MpxPlaylist;
			}
		}, {
			key: 'getParselyPlaylist',
			value: function getParselyPlaylist(postId) {
				if (this.parselyPlaylist) {
					return this.parselyPlaylist;
				}
	
				this.parselyPlaylist = (0, _FetchService.get)(_constants.settings.PARSELY_URL + postId, function (json) {
					if (!json.success) return [];
					var data = json.data;
					return Array.isArray(data) ? data : [data];
				}, function () {
					return [];
				});
	
				return this.parselyPlaylist;
			}
		}, {
			key: 'getParselyContentByTags',
			value: function getParselyContentByTags() {
				var parselyFeedTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
				var defaultVideoTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
				var postId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
				if (this.parselyPlaylist) {
					return this.parselyPlaylist;
				}
	
				var tags = '?parselytags=' + parselyFeedTags + (defaultVideoTags && '&defaulttags=' + defaultVideoTags) + '&postid=' + postId;
				this.parselyPlaylist = (0, _FetchService.get)(_constants.settings.PARSELY_URL_V2 + tags, function (json) {
					if (!json.success) return [];
					var data = json.data;
					return Array.isArray(data) ? data : [data];
				}, function () {
					return [];
				});
	
				return this.parselyPlaylist;
			}
		}, {
			key: 'getParselyContentByFeed',
			value: function getParselyContentByFeed(feedUrl) {
				var postId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
				if (this.playlist) {
					return this.playlist;
				}
	
				var url = '?feedurl=' + encodeURIComponent(feedUrl) + '&postid=' + postId;
				this.playlist = (0, _FetchService.get)(_constants.settings.PARSELY_URL_V2 + url, function (json) {
					if (!json.success) return [];
					var data = json.data;
					return Array.isArray(data) ? data : [data];
				}, function () {
					return [];
				});
	
				return this.playlist;
			}
		}]);
	
		return FsPlaylistService;
	}();
	
	exports.default = FsPlaylistService;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var settings = exports.settings = {
		COLLECTIONS_URL: '/wp-json/fsd/v1/wp/video-collections/',
		MPX_PLAYLIST_URL: '/wp-json/fsd/v1/wp/mpx-related-videos',
		PARSELY_URL: '/wp-json/fsd/v1/wp/parsely-content/',
		PARSELY_URL_V2: '/wp-json/fsd/v1/wp/parsely-content-v2/'
	};
	
	var global = exports.global = {
		FSGO_URL: 'https://www.foxsportsgo.com/'
	};
	
	var widthRange = exports.widthRange = {
		DESKTOP: '1280+',
		LAPTOP: '1024-1279',
		TABLET: '768-1023',
		MOBILE: '-767',
	
		DESKTOP_MOBILE: '-767,1280+',
		TABLET_LAPTOP: '768-1279'
	};
	
	var shareLinks = exports.shareLinks = {
		FB_SHARE: 'https://www.facebook.com/sharer/sharer.php?u=',
		TWITTER_SHARE: 'https://twitter.com/intent/tweet?url=',
		GOOGLE_PLUS: 'https://plus.google.com/share?url=',
		MAIL: 'mailto:?subject='
	};
	
	var urlFilterObj = exports.urlFilterObj = {
		'auto_nascar': 'nascar',
		'motorsports': 'motor',
		'ncaa_football': 'college-football'
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.get = get;
	exports.post = post;
	
	var _isomorphicFetch = __webpack_require__(6);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchData(url, options, callback, error) {
		return (0, _isomorphicFetch2.default)(url, options).then(_utils.handleFetchedErrors).then(function (response) {
			return response.json();
		}).then(callback).catch(error);
	}
	
	function get(url, callback, error) {
		var options = Object.assign({ method: 'GET' }, _utils.headers);
	
		return fetchData(url, options, callback, error);
	}
	
	function post(url, data, callback, error) {
		var options = Object.assign({ method: 'POST', body: JSON.stringify(data) }, _utils.headers);
	
		return fetchData(url, options, callback, error);
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(7);
	module.exports = self.fetch.bind(self);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isTabletOrMobile = exports.isFlashEnabled = exports.assetsDomain = exports.headers = undefined;
	exports.handleFetchedErrors = handleFetchedErrors;
	exports.getPostId = getPostId;
	exports.decodeText = decodeText;
	exports.decodeHtmlEntities = decodeHtmlEntities;
	exports.parseImagesTag = parseImagesTag;
	exports.parseSeconds = parseSeconds;
	exports.fbShareParselyTrackLink = fbShareParselyTrackLink;
	exports.getFbShareUrl = getFbShareUrl;
	exports.getQueryString = getQueryString;
	
	var _utils = __webpack_require__(9);
	
	var _TrackingUtils = __webpack_require__(10);
	
	var _TrackingUtils2 = _interopRequireDefault(_TrackingUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headers = exports.headers = {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	
	};
	
	function handleFetchedErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
	
		return response;
	}
	
	function getPostId() {
		var pageInfo = document.getElementById('page-information');
		if (pageInfo) {
			var body = document.querySelector('.fox_sectionfront .body-content');
			if (body) {
				return body.getAttribute('post-id');
			}
		}
	
		return document.body.getAttribute('post-id');
	}
	
	function getAssetsDomain() {
		var locationName = location.hostname;
	
		if (locationName.match(/www.foxsports.com/)) {
			return 'https://b.fssta.com/sta/';
		}
	
		if (locationName.match(/wp.foxsports.com/)) {
			return 'https://b.dev.fssta.com/sta/';
		}
	
		return '/wp-content/themes/foxsports/assets/dist/';
	}
	
	var assetsDomain = exports.assetsDomain = getAssetsDomain();
	
	function decodeText(text) {
		return text.replace(/\&#(\d*)\;/g, function (s) {
			return decodeTable[s] || '';
		});
	}
	
	function decodeHtmlEntities(text) {
		return text.replace(/\&(\w*|#\d*)\;/g, function (s) {
			return HTMLEntitiesTable[s] || '';
		});
	}
	
	var HTMLEntitiesTable = {
		'&amp;': '&',
		'&quot;': '"',
		'&#039;': "'",
		'&lt;': '<',
		'&gt;': '>'
	};
	
	var decodeTable = {
		'&#32;': ' ',
		'&#33;': '!',
		'&#34;': '"',
		'&#35;': '#',
		'&#36;': '$',
		'&#37;': '%',
		'&#38;': '&',
		'&#39;': '\'',
		'&#40;': '(',
		'&#41;': ')',
		'&#42;': '*',
		'&#43;': '+',
		'&#44;': ',',
		'&#45;': '-',
		'&#46;': '.',
		'&#47;': '/',
	
		'&#8211;': '–',
		'&#8212;': '—',
		'&#8216;': '‘',
		'&#8217;': '’',
		'&#8218;': '‚',
		'&#8220;': '“',
		'&#8221;': '”',
		'&#8222;': '„',
		'&#8224;': '†',
		'&#8225;': '‡',
		'&#8226;': '•',
		'&#8230;': '…',
		'&#8240;': '‰',
		'&#8364;': '€',
		'&#8482;': '™'
	};
	
	function parseImagesTag(text) {
		text = '<div>' + text + '</div>';
		var parser = new DOMParser();
	
		var result = {
			srcSet: '',
			sizes: '',
			src: '',
			noscript: ''
		};
	
		try {
			var el = parser.parseFromString(text, 'text/html');
			var images = el.getElementsByTagName('img');
	
			if (images.length > 0) {
				var img = images[0];
	
				result.sizes = img.getAttribute('data-sizes') || img.getAttribute('sizes');
				result.srcSet = img.getAttribute('data-srcset') || img.getAttribute('srcset');
				result.src = img.getAttribute('data-src') || img.getAttribute('src');
			}
	
			var noscripts = el.getElementsByTagName('noscript');
	
			if (noscripts.length > 0) {
				var noscript = noscripts[0];
	
				result.noscript = noscript.innerHTML;
			}
		} finally {
			return result;
		}
	}
	
	function parseSeconds(time) {
		if (!time || time.indexOf('.') === -1) {
			return time;
		}
	
		var minutes = Math.floor(time / 60);
		var seconds = Math.floor(time - minutes * 60);
	
		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}
	
	function isFlashEnabledFn() {
		var hasFlash = false;
	
		try {
			if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] ? navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin : 0) {
				hasFlash = true;
			}
		} catch (e) {
			if (navigator.mimeTypes['application/x-shockwave-flash'] != undefined) {
				hasFlash = true;
			}
		}
	
		return hasFlash;
	}
	
	var isFlashEnabled = exports.isFlashEnabled = isFlashEnabledFn();
	
	function isTabletOrMobileFn() {
		return navigator.userAgent.match(/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	}
	
	var isTabletOrMobile = exports.isTabletOrMobile = isTabletOrMobileFn();
	
	function getUtmTerm() {
		var pageType = (0, _utils.getPageMeta)()['page_type'];
		return pageType == 'home' ? 'homepage' : pageType == 'section front' ? 'sf' : 'post';
	}
	
	var UTM_TERM = getUtmTerm();
	
	function fbShareParselyTrackLink(e) {
	
		var trackingObject = {
			'utm_campaign': 'share_buttons',
			'utm_source': 'share_fb',
			'utm_medium': 'fscom',
			'utm_content': 'original_share',
			'utm_term': UTM_TERM
		};
	
		_TrackingUtils2.default.ParselyTrackLink(e, trackingObject);
	}
	
	function getFbShareUrl(url) {
		var utmParam = 'utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit&utm_term=' + UTM_TERM + '&utm_source=share_fb';
		var utmUrl = url + '?' + utmParam;
	
		return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(utmUrl);
	}
	
	/**
	 * Get the value of a querystring
	 * @param  {String} field The field to get the value of
	 * @param  {String} url   The URL to get the value from (optional)
	 * @return {String}       The field value
	 */
	function getQueryString(field, url) {
		var href = url ? url : window.location.href;
		var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
		var string = reg.exec(href);
		return string ? string[1] : null;
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPageMeta = getPageMeta;
	/**
	 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
	 * @returns {object} Meta Object
	 */
	function getPageMeta() {
	
		var data = {};
		var metaEl = document.querySelector('[fs-prop="analytics"]');
		var attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category', 'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title', 'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name', 'page-attribute', 'testScorestripPosition'];
	
		/**
	  *  to enforce html semantic, we use dashes for property names.
	  *  We need to do the dashes replacement with underscore since
	  *  analytic script uses underscore in the properties
	  */
		for (var i = 0, l = attributes.length; i < l; i++) {
			var attr = attributes[i];
			var val = metaEl.getAttribute(attr);
	
			if (val != null) {
				attr = attr.indexOf('-') >= 0 ? attr.replace(/-/g, '_') : attr;
				data[attr] = val.trim();
			}
		}
	
		return data;
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrackingUtils = function () {
	    function TrackingUtils() {
	        _classCallCheck(this, TrackingUtils);
	
	        this.isLogEnabled = false;
	        this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	        this.checkLogEnabled();
	    }
	
	    _createClass(TrackingUtils, [{
	        key: 'log',
	        value: function log(message) {
	            this.isLogEnabled && console.log(message);
	        }
	    }, {
	        key: 'checkLogEnabled',
	        value: function checkLogEnabled() {
	            this.isLogEnabled = location.href.indexOf('trackinglog=true') > -1 ? true : false;
	        }
	
	        /**
	         * set tracking for link element
	         * @param {*} links
	         * @param {*} service
	         * @param {*} trackingObj
	         *     Example:
	         *        TrackingUtils.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
	         *            'utm_campaign'  : 'more_videos',
	         *            'utm_medium'    : 'fscom',
	         *            'utm_content'   : 'morelink'
	         *        });
	         */
	
	    }, {
	        key: 'setLinkTracking',
	        value: function setLinkTracking(links, service, trackingObj) {
	            var _this = this;
	
	            if (!links || !links.length || !service) return;
	
	            if (links.constructor.name === 'NodeList') {
	                links = [].concat(_toConsumableArray(links));
	            }
	
	            for (var i = 0, lLen = links.length; i < lLen; i++) {
	                var link = links[i];
	                if (link.hasAttribute('data-link-tracked-by')) break;
	
	                if ('parsely' === service) {
	                    link.addEventListener('click', function (e) {
	                        _this.ParselyTrackLink(e, trackingObj);
	                    });
	                }
	                link.setAttribute('data-link-tracked-by', service);
	            }
	        }
	
	        /**
	         * add to target's event.addEventListener
	         * @param {*} ev
	        * @param trackingObj
	         */
	
	    }, {
	        key: 'ParselyTrackLink',
	        value: function ParselyTrackLink(ev, trackingObj) {
	            if (ev.preventDefault) ev.preventDefault();
	
	            var target = ev.currentTarget || ev.target;
	            var url = target.getAttribute('href');
	            var urlToTrack = target.getAttribute('data-url-to-track');
	
	            if (typeof PARSELY !== "undefined" && _typeof(PARSELY.beacon) === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
	                var parselyObj = {
	                    'url': this.addTrackingQuery(trackingObj, urlToTrack || url),
	                    'js': 1
	                };
	
	                PARSELY.beacon.trackPageView(parselyObj);
	            }
	
	            window.open(url, target.getAttribute('target') || '_self');
	        }
	
	        /**
	         * constructing url param by using JS object (wrapping function)
	         * @param {*} trackingObj
	         * @param {*} url
	         */
	
	    }, {
	        key: 'addTrackingQuery',
	        value: function addTrackingQuery(trackingObj, url) {
	            for (var i in trackingObj) {
	                var val = trackingObj[i];
	                if (val) {
	                    url = this.updateQueryStringParam(url, i, val);
	                }
	            }
	            return url;
	        }
	
	        /**
	         * constructing url param by using JS object (actual logic)
	         * based on "https://stackoverflow.com/a/6021027"
	         * @param {*} uri
	         * @param {*} key
	         * @param {*} value
	         */
	
	    }, {
	        key: 'updateQueryStringParam',
	        value: function updateQueryStringParam(uri, key, value) {
	            var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
	            if (uri.match(re)) {
	                return uri.replace(re, '$1' + key + "=" + value + '$2');
	            } else {
	                var hash = '';
	                if (uri.indexOf('#') !== -1) {
	                    hash = uri.replace(/.*#/, '#');
	                    uri = uri.replace(/#.*/, '');
	                }
	                var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	                return uri + separator + key + "=" + value + hash;
	            }
	        }
	
	        /**
	         * Replace empty spaces with dashes
	         * @param {string} str
	         */
	
	    }, {
	        key: 'replaceSpacesWithDash',
	        value: function replaceSpacesWithDash(str) {
	            return str.replace(/ /g, "-");
	        }
	
	        /**
	         * get vide title, image and section from video player info
	         * @returns Object {{title: string, image_url: string}}
	         */
	
	    }, {
	        key: 'getTrackingMeta',
	        value: function getTrackingMeta(player) {
	
	            var title = '';
	            var thumbnail = '';
	            var section = '';
	            var id = '';
	            var url = '';
	
	            if (typeof player.videoinfo.thumbnail !== "undefined") {
	                thumbnail = player.videoinfo.thumbnail;
	            }
	
	            if (typeof player.videoinfo.title !== "undefined") {
	                title = player.videoinfo.title;
	            }
	
	            if (typeof player.videoinfo.primary !== "undefined") {
	                section = player.videoinfo.primary;
	            }
	
	            if (typeof player.videoinfo.id !== "undefined") {
	                id = player.videoinfo.id;
	            }
	
	            if (typeof player.url !== "undefined") {
	                url = player.url;
	            }
	
	            return {
	                title: title,
	                image_url: thumbnail,
	                section: section,
	                id: id,
	                url: url
	            };
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart and OnMediaUnpause events
	         * @param isAd True or False for e.data.baseClip.isAd that is passed from player OnMediaStart and OnMediaUnpause events
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPlay',
	        value: function sendPlay(isAd, player, utmObj) {
	            //only send parsely tracking on video play when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("play", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart event
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPause',
	        value: function sendPause(isAd, player, utmObj) {
	
	            this.isPlaying = false;
	            this.isPaused = true;
	
	            //only send parsely tracking on video pause when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("pause", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc Send parsely tracking when video is played or paused
	         * parsely doc: https://www.parsely.com/help/integration/video/
	         * @param type
	         * @param metadata
	         * @param utmObj
	         */
	
	    }, {
	        key: 'sendTracking',
	        value: function sendTracking(type, metadata, utmObj) {
	
	            //if only send parsely tracking when there is video ID and PARSELY is available
	            var isParsely = typeof PARSELY !== 'undefined' && _typeof(PARSELY.video) === 'object';
	            if (typeof metadata !== "undefined" && metadata.id !== "undefined" && isParsely) {
	
	                /**
	                 * we only include title, image_url and section for tracking
	                 * We don't have pub_date_tmsp, tags and authors from the video player info.
	                 * We can get them, but it will require additional server call for the videos,
	                 * so we skip including them at this moment
	                 */
	                var urlOverride = metadata.url !== '' ? metadata.url : location.origin + location.pathname;
	                //let metadata = this.getTrackingMeta();
	
	                metadata.section = utmObj.utm_content || utmObj.utm_section;
	                urlOverride = this.addTrackingQuery(utmObj, urlOverride);
	
	                //the following log info for debugging purpose on the console. We will remove it when we release it to prod
	                this.log('\n                    VIDEO TRACKING: sending parsely data\n                    type: ' + type + '\n                    title: ' + metadata.title + '\n                    thumbnail: ' + metadata.image_url + '\n                    vid: ' + metadata.id + '\n                    urlOverride: ' + urlOverride + '\n                    config: ' + JSON.stringify(metadata) + ' \n            ');
	
	                try {
	                    if (type === 'play') {
	                        PARSELY.video.trackPlay(metadata.id, metadata, urlOverride);
	                    } else if (type === 'pause') {
	                        PARSELY.video.trackPause(metadata.id, metadata, urlOverride);
	                    } else {
	                        console.log("Tracking Type Not Supported", type);
	                    }
	                } catch (err) {
	                    console.log("Error sending tracking info: ", err);
	                }
	            }
	        }
	
	        /**
	         * @desc replace string to a slug-like format
	         * @returns String
	         * i.e., "This Is A Slug!" = "this-is-a-slug"
	         */
	
	    }, {
	        key: 'formatStringAsSlug',
	        value: function formatStringAsSlug(str) {
	            return str.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
	        }
	
	        /**
	         * It is trackable for page view if it is on section front page and the video config include video id in url
	         * @param string videoId 
	         * @param string currentUrl
	         * @returns {boolean} 
	         */
	
	    }, {
	        key: 'isTrackable',
	        value: function isTrackable(videoId, currentUrl) {
	            //return true if id from url match the current url id does not match
	            return '' !== videoId && currentUrl.substr(currentUrl.lastIndexOf('/') + 1) !== videoId;
	        }
	
	        /**
	         * format object for UTM tracking use
	         * @param {obj} unformatted utm object
	         */
	
	    }, {
	        key: 'getUtmObj',
	        value: function getUtmObj(obj) {
	            var result = {};
	            // loop through object and reformatting property names for UTM tracking
	            for (var item in obj) {
	                switch (item) {
	                    case "campaign":
	                    case "section":
	                    case "source":
	                    case "medium":
	                    case "content":
	                    case "term":
	                        result["utm_" + item] = obj[item];
	                        break;
	                    default:
	                        break;
	                }
	            }
	            // failover check for "utm_campaign" and "utm_medium"
	            result["utm_campaign"] = result["utm_campaign"] || "video_playback_location";
	            if (typeof result["utm_medium"] === 'undefined') {
	                if (typeof this.isBB !== 'undefined') {
	                    this.isSectionFront = document.body.classList.contains('single-fox_sectionfront');
	                    this.isMediaHub = document.body.classList.contains('single-fox_media_hub');
	                    this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	                }
	                result["utm_medium"] = this.isBB ? 'bb_video_player' : 'video_player';
	            }
	            return result;
	        }
	
	        /**
	         * Gets utm params based on the Page Name property from the video config object
	         * Format for the page name params is i.e fscom:nfl:section-front:featured-content
	         * [0] = site
	         * [1] = section/category - (utm_content)
	         * [2] = page type - (utm_source)
	         * [3] = term - (utm_term)
	         * @param {string} pageName
	         */
	
	    }, {
	        key: 'getUtmParams',
	        value: function getUtmParams(pageName) {
	            pageName = pageName.split(':');
	
	            return {
	                site: pageName[0] || '',
	                section: pageName[1] || '',
	                source: pageName[2] || '',
	                term: pageName[3] || ''
	
	            };
	        }
	    }]);
	
	    return TrackingUtils;
	}();
	
	exports.default = new TrackingUtils();

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Viewports = function () {
	    function Viewports() {
	        var _this = this;
	
	        var viewports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'mobile': 767, 'tablet': 768, 'desktop': 1024 };
	
	        _classCallCheck(this, Viewports);
	
	        var userAgent = window.navigator.userAgent;
	
	        this.winW = window.innerWidth;
	        this.winH = window.innerHeight;
	        this.docW = document.body.clientWidth;
	        this.isIOSSafari = userAgent.match(/iPhone|iPod|iPad/i) && userAgent.match(/Safari/i) && userAgent.match(/Chrome|CriOS/i) === null;
	        this.isIOS = userAgent.match(/iPhone|iPod|iPad/i);
	        this.isIphone = userAgent.match(/iPhone/i);
	        this.isAndroid = userAgent.match(/Android/i);
	        this.isIPad = userAgent.match(/iPad/i);
	        this.isMobile = userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	        this.isTouch = userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
	        this.viewPorts = viewports;
	
	        window.addEventListener("resize", function () {
	            _this.setWinW(window.innerWidth);
	            _this.setWinH(window.innerHeight);
	            _this.setDocW(document.body.clientWidth);
	        });
	    }
	
	    //setter for window inner width
	
	
	    _createClass(Viewports, [{
	        key: 'setWinW',
	        value: function setWinW(w) {
	            this.winW = w;
	        }
	
	        //getter for window inner width
	
	    }, {
	        key: 'getWinW',
	        value: function getWinW() {
	            return this.winW;
	        }
	
	        //setter for document body clientWidth
	
	    }, {
	        key: 'setDocW',
	        value: function setDocW(w) {
	            this.docW = w;
	        }
	
	        //getter for document body clientWidth
	
	    }, {
	        key: 'getDocW',
	        value: function getDocW() {
	            return this.docW;
	        }
	
	        //setter for winH
	
	    }, {
	        key: 'setWinH',
	        value: function setWinH(h) {
	            this.winH = h;
	        }
	
	        //getter for winH
	
	    }, {
	        key: 'getWinH',
	        value: function getWinH() {
	            return this.winH;
	        }
	    }, {
	        key: 'getViewPort',
	        value: function getViewPort() {
	            var winW = this.winW;
	            return winW <= this.viewPorts.mobile ? 'mobile' : winW >= this.viewPorts.desktop ? 'desktop' : 'tablet';
	        }
	
	        /**
	         * @desc checking element is in view. This function works well to determine if the element is in view,
	         * but it takes a little time to do the calculation to get top, bottom, left and right positions
	         * @param object el
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmInViewport',
	        value: function isElmInViewport(el) {
	
	            var rect = el.getBoundingClientRect();
	
	            return rect && rect.top >= 0 && rect.left >= 0 && rect.bottom <= this.winH && rect.right <= this.winW;
	        }
	
	        /**
	         * @desc checking element top postion is passing . This function works faster than the above isElmInViewport ,
	         * since we only need to check elment top position. This should be good to use if we just want to check the scroll
	         * position and doing pinning or lazyloading the scripts
	         * @param dom object el
	         * @param Number offet: passing an offet here if we want the scroll event rendered a bit early
	         * @return bool - true or false
	         */
	
	    }, {
	        key: 'isElmTopPosPassing',
	        value: function isElmTopPosPassing(el, offet) {
	
	            var rect = el.getBoundingClientRect();
	            var checkPos = undefined;
	
	            if (offet !== undefined && !isNaN(offet)) {
	                checkPos = rect.top - offet;
	            } else {
	                checkPos = rect.top;
	            }
	
	            return checkPos <= this.winH;
	        }
	    }]);
	
	    return Viewports;
	}();
	
	exports.default = Viewports;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoPlayerService = __webpack_require__(14);
	
	var _noImportant = __webpack_require__(15);
	
	var _fsPlayerUtils = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FsPlayer = function (_React$Component) {
		_inherits(FsPlayer, _React$Component);
	
		function FsPlayer(props) {
			_classCallCheck(this, FsPlayer);
	
			var _this = _possibleConstructorReturn(this, (FsPlayer.__proto__ || Object.getPrototypeOf(FsPlayer)).call(this, props));
	
			_this.state = {
				playerConfig: _this.props.playerConfig
			};
			return _this;
		}
	
		_createClass(FsPlayer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate() {}
		}, {
			key: 'render',
			value: function render() {
	
				var playerConfig = this.props.playerConfig;
				//reformat url to jw player format
				if (document.body.classList.contains('jw-player')) {
					playerConfig.releaseURL = (0, _fsPlayerUtils.reformatReleaseUrl)(playerConfig.releaseURL);
				}
	
				var pinClass = document.body.classList.contains('pin-top') ? 'pin-top' : '';
				if (playerConfig instanceof Object) {
					playerConfig = (0, _VideoPlayerService.preparePlayerConfig)(playerConfig);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: 'fs-player' },
					_react2.default.createElement(
						'div',
						{ className: 'fs-pin-wrapper' },
						_react2.default.createElement(
							'div',
							{ className: 'fs-pin-cont' },
							_react2.default.createElement('div', { className: 'fs-video-details' }),
							_react2.default.createElement(
								'div',
								{ className: "platformPlayer-wrapper " + pinClass },
								_react2.default.createElement('div', { ref: this.props.playerRef,
									className: (0, _noImportant.css)(styles.playerStyles) + " fs-video-player",
									'data-player-config': playerConfig })
							)
						)
					)
				);
			}
		}]);
	
		return FsPlayer;
	}(_react2.default.Component);
	
	exports.default = FsPlayer;
	
	
	var styles = _noImportant.StyleSheet.create({
		playerStyles: {
			height: 'auto !important',
			width: '100% !important',
			paddingBottom: '56% !important',
			position: 'absolute'
		}
	});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.loadVideoPlayer = loadVideoPlayer;
	exports.preparePlayerConfig = preparePlayerConfig;
	function loadVideoPlayer(player, width, height, prepareContainer) {
		player.style.width = width + 'px';
		player.style.height = height + 'px';
		player.classList.add('platformPlayer');
	
		if (prepareContainer instanceof Function) {
			prepareContainer();
		}
	
		var loader = window.criticalVideoLoader;
		var configData = loader.getVideoElementsData().map(function (data) {
			return data;
		});
	
		loader.loadScript(loader.loadVideos.bind(loader), configData, true);
	}
	
	function preparePlayerConfig(playerConfig) {
		var result = Object.assign({}, playerConfig);
		result = replaceWithDashes(result, ['iu', 'categoryName', 'siteSection', 'pageName']);
	
		return JSON.stringify(result);
	}
	
	function replaceWithDashes(playerConfig, propNames) {
		propNames.forEach(function (propName) {
			if (typeof playerConfig[propName] === 'string' || playerConfig[propName] instanceof String) {
				playerConfig[propName] = playerConfig[propName].replace(/%20/g, '-');
			}
		});
	
		return playerConfig;
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(16);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	
	// Module with the same interface as the core aphrodite module,
	// except that styles injected do not automatically have !important
	// appended to them.
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _generate = __webpack_require__(17);
	
	var _exports2 = __webpack_require__(43);
	
	var _exports3 = _interopRequireDefault(_exports2);
	
	var useImportant = false; // Don't add !important to style definitions
	exports['default'] = (0, _exports3['default'])(useImportant, _generate.defaultSelectorHandlers);
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _inlineStylePrefixerStaticCreatePrefixer = __webpack_require__(18);
	
	var _inlineStylePrefixerStaticCreatePrefixer2 = _interopRequireDefault(_inlineStylePrefixerStaticCreatePrefixer);
	
	var _libStaticPrefixData = __webpack_require__(24);
	
	var _libStaticPrefixData2 = _interopRequireDefault(_libStaticPrefixData);
	
	var _orderedElements = __webpack_require__(40);
	
	var _orderedElements2 = _interopRequireDefault(_orderedElements);
	
	var _util = __webpack_require__(41);
	
	var prefixAll = (0, _inlineStylePrefixerStaticCreatePrefixer2['default'])(_libStaticPrefixData2['default']);
	
	/* ::
	import type { SheetDefinition } from './index.js';
	type StringHandlers = { [id:string]: Function };
	type SelectorCallback = (selector: string) => any;
	export type SelectorHandler = (
	    selector: string,
	    baseSelector: string,
	    callback: SelectorCallback
	) => string | null;
	*/
	
	/**
	 * `selectorHandlers` are functions which handle special selectors which act
	 * differently than normal style definitions. These functions look at the
	 * current selector and can generate CSS for the styles in their subtree by
	 * calling the callback with a new selector.
	 *
	 * For example, when generating styles with a base selector of '.foo' and the
	 * following styles object:
	 *
	 *   {
	 *     ':nth-child(2n)': {
	 *       ':hover': {
	 *         color: 'red'
	 *       }
	 *     }
	 *   }
	 *
	 * when we reach the ':hover' style, we would call our selector handlers like
	 *
	 *   handler(':hover', '.foo:nth-child(2n)', callback)
	 *
	 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
	 * the callback like
	 *
	 *   callback('.foo:nth-child(2n):hover')
	 *
	 * to generate its subtree `{ color: 'red' }` styles with a
	 * '.foo:nth-child(2n):hover' selector. The callback would return CSS like
	 *
	 *   '.foo:nth-child(2n):hover{color:red !important;}'
	 *
	 * and the handler would then return that resulting CSS.
	 *
	 * `defaultSelectorHandlers` is the list of default handlers used in a call to
	 * `generateCSS`.
	 *
	 * @name SelectorHandler
	 * @function
	 * @param {string} selector: The currently inspected selector. ':hover' in the
	 *     example above.
	 * @param {string} baseSelector: The selector of the parent styles.
	 *     '.foo:nth-child(2n)' in the example above.
	 * @param {function} generateSubtreeStyles: A function which can be called to
	 *     generate CSS for the subtree of styles corresponding to the selector.
	 *     Accepts a new baseSelector to use for generating those styles.
	 * @returns {?string} The generated CSS for this selector, or null if we don't
	 *     handle this selector.
	 */
	var defaultSelectorHandlers = [
	// Handle pseudo-selectors, like :hover and :nth-child(3n)
	function pseudoSelectors(selector, /* : string */
	baseSelector, /* : string */
	generateSubtreeStyles /* : Function */
	) /* */{
	    if (selector[0] !== ":") {
	        return null;
	    }
	    return generateSubtreeStyles(baseSelector + selector);
	},
	
	// Handle media queries (or font-faces)
	function mediaQueries(selector, /* : string */
	baseSelector, /* : string */
	generateSubtreeStyles /* : Function */
	) /* */{
	    if (selector[0] !== "@") {
	        return null;
	    }
	    // Generate the styles normally, and then wrap them in the media query.
	    var generated = generateSubtreeStyles(baseSelector);
	    return selector + '{' + generated + '}';
	}];
	
	exports.defaultSelectorHandlers = defaultSelectorHandlers;
	/**
	 * Generate CSS for a selector and some styles.
	 *
	 * This function handles the media queries and pseudo selectors that can be used
	 * in aphrodite styles.
	 *
	 * @param {string} selector: A base CSS selector for the styles to be generated
	 *     with.
	 * @param {Object} styleTypes: A list of properties of the return type of
	 *     StyleSheet.create, e.g. [styles.red, styles.blue].
	 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
	 *     handlers to use for handling special selectors. See
	 *     `defaultSelectorHandlers`.
	 * @param stringHandlers: See `generateCSSRuleset`
	 * @param useImportant: See `generateCSSRuleset`
	 *
	 * To actually generate the CSS special-construct-less styles are passed to
	 * `generateCSSRuleset`.
	 *
	 * For instance, a call to
	 *
	 *     generateCSS(".foo", [{
	 *       color: "red",
	 *       "@media screen": {
	 *         height: 20,
	 *         ":hover": {
	 *           backgroundColor: "black"
	 *         }
	 *       },
	 *       ":active": {
	 *         fontWeight: "bold"
	 *       }
	 *     }], defaultSelectorHandlers);
	 *
	 * with the default `selectorHandlers` will make 5 calls to
	 * `generateCSSRuleset`:
	 *
	 *     generateCSSRuleset(".foo", { color: "red" }, ...)
	 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
	 *     // These 2 will be wrapped in @media screen {}
	 *     generateCSSRuleset(".foo", { height: 20 }, ...)
	 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
	 */
	var generateCSS = function generateCSS(selector, /* : string */
	styleTypes, /* : SheetDefinition[] */
	selectorHandlers, /* : SelectorHandler[] */
	stringHandlers, /* : StringHandlers */
	useImportant /* : boolean */
	) /* : string */{
	    var merged = new _orderedElements2['default']();
	
	    for (var i = 0; i < styleTypes.length; i++) {
	        merged.addStyleType(styleTypes[i]);
	    }
	
	    var plainDeclarations = new _orderedElements2['default']();
	    var generatedStyles = "";
	
	    // TODO(emily): benchmark this to see if a plain for loop would be faster.
	    merged.forEach(function (val, key) {
	        // For each key, see if one of the selector handlers will handle these
	        // styles.
	        var foundHandler = selectorHandlers.some(function (handler) {
	            var result = handler(key, selector, function (newSelector) {
	                return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
	            });
	            if (result != null) {
	                // If the handler returned something, add it to the generated
	                // CSS and stop looking for another handler.
	                generatedStyles += result;
	                return true;
	            }
	        });
	        // If none of the handlers handled it, add it to the list of plain
	        // style declarations.
	        if (!foundHandler) {
	            plainDeclarations.set(key, val, true);
	        }
	    });
	
	    return generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers) + generatedStyles;
	};
	
	exports.generateCSS = generateCSS;
	/**
	 * Helper method of generateCSSRuleset to facilitate custom handling of certain
	 * CSS properties. Used for e.g. font families.
	 *
	 * See generateCSSRuleset for usage and documentation of paramater types.
	 */
	var runStringHandlers = function runStringHandlers(declarations, /* : OrderedElements */
	stringHandlers, /* : StringHandlers */
	selectorHandlers /* : SelectorHandler[] */
	) /* : void */{
	    if (!stringHandlers) {
	        return;
	    }
	
	    var stringHandlerKeys = Object.keys(stringHandlers);
	    for (var i = 0; i < stringHandlerKeys.length; i++) {
	        var key = stringHandlerKeys[i];
	        if (declarations.has(key)) {
	            // A declaration exists for this particular string handler, so we
	            // need to let the string handler interpret the declaration first
	            // before proceeding.
	            //
	            // TODO(emily): Pass in a callback which generates CSS, similar to
	            // how our selector handlers work, instead of passing in
	            // `selectorHandlers` and have them make calls to `generateCSS`
	            // themselves. Right now, this is impractical because our string
	            // handlers are very specialized and do complex things.
	            declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers),
	
	            // Preserve order here, since we are really replacing an
	            // unprocessed style with a processed style, not overriding an
	            // earlier style
	            false);
	        }
	    }
	};
	
	var transformRule = function transformRule(key, /* : string */
	value, /* : string */
	transformValue /* : function */
	) {
	    return (/* : string */(0, _util.kebabifyStyleName)(key) + ':' + transformValue(key, value) + ';'
	    );
	};
	
	/**
	 * Generate a CSS ruleset with the selector and containing the declarations.
	 *
	 * This function assumes that the given declarations don't contain any special
	 * children (such as media queries, pseudo-selectors, or descendant styles).
	 *
	 * Note that this method does not deal with nesting used for e.g.
	 * psuedo-selectors or media queries. That responsibility is left to  the
	 * `generateCSS` function.
	 *
	 * @param {string} selector: the selector associated with the ruleset
	 * @param {Object} declarations: a map from camelCased CSS property name to CSS
	 *     property value.
	 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
	 *     property name to a function which will map the given value to the value
	 *     that is output.
	 * @param {bool} useImportant: A boolean saying whether to append "!important"
	 *     to each of the CSS declarations.
	 * @returns {string} A string of raw CSS.
	 *
	 * Examples:
	 *
	 *    generateCSSRuleset(".blah", { color: "red" })
	 *    -> ".blah{color: red !important;}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
	 *    -> ".blah{color: red}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
	 *    -> ".blah{color: RED}"
	 *    generateCSSRuleset(".blah:hover", { color: "red" })
	 *    -> ".blah:hover{color: red}"
	 */
	var generateCSSRuleset = function generateCSSRuleset(selector, /* : string */
	declarations, /* : OrderedElements */
	stringHandlers, /* : StringHandlers */
	useImportant, /* : boolean */
	selectorHandlers /* : SelectorHandler[] */
	) /* : string */{
	    // Mutates declarations
	    runStringHandlers(declarations, stringHandlers, selectorHandlers);
	
	    var originalElements = _extends({}, declarations.elements);
	
	    // NOTE(emily): This mutates handledDeclarations.elements.
	    var prefixedElements = prefixAll(declarations.elements);
	
	    var elementNames = Object.keys(prefixedElements);
	    if (elementNames.length !== declarations.keyOrder.length) {
	        // There are some prefixed values, so we need to figure out how to sort
	        // them.
	        //
	        // Loop through prefixedElements, looking for anything that is not in
	        // sortOrder, which means it was added by prefixAll. This means that we
	        // need to figure out where it should appear in the sortOrder.
	        for (var i = 0; i < elementNames.length; i++) {
	            if (!originalElements.hasOwnProperty(elementNames[i])) {
	                // This element is not in the sortOrder, which means it is a prefixed
	                // value that was added by prefixAll. Let's try to figure out where it
	                // goes.
	                var originalStyle = undefined;
	                if (elementNames[i][0] === 'W') {
	                    // This is a Webkit-prefixed style, like "WebkitTransition". Let's
	                    // find its original style's sort order.
	                    originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
	                } else if (elementNames[i][1] === 'o') {
	                    // This is a Moz-prefixed style, like "MozTransition". We check
	                    // the second character to avoid colliding with Ms-prefixed
	                    // styles. Let's find its original style's sort order.
	                    originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
	                } else {
	                    // if (elementNames[i][1] === 's') {
	                    // This is a Ms-prefixed style, like "MsTransition".
	                    originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
	                }
	
	                if (originalStyle && originalElements.hasOwnProperty(originalStyle)) {
	                    var originalIndex = declarations.keyOrder.indexOf(originalStyle);
	                    declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
	                } else {
	                    // We don't know what the original style was, so sort it to
	                    // top. This can happen for styles that are added that don't
	                    // have the same base name as the original style.
	                    declarations.keyOrder.unshift(elementNames[i]);
	                }
	            }
	        }
	    }
	
	    var transformValue = useImportant === false ? _util.stringifyValue : _util.stringifyAndImportantifyValue;
	
	    var rules = [];
	    for (var i = 0; i < declarations.keyOrder.length; i++) {
	        var key = declarations.keyOrder[i];
	        var value = prefixedElements[key];
	        if (Array.isArray(value)) {
	            // inline-style-prefixer returns an array when there should be
	            // multiple rules for the same key. Here we flatten to multiple
	            // pairs with the same key.
	            for (var j = 0; j < value.length; j++) {
	                rules.push(transformRule(key, value[j], transformValue));
	            }
	        } else {
	            rules.push(transformRule(key, value, transformValue));
	        }
	    }
	
	    if (rules.length) {
	        return selector + '{' + rules.join("") + '}';
	    } else {
	        return "";
	    }
	};
	exports.generateCSSRuleset = generateCSSRuleset;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(19);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(21);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(22);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(23);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(20);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var calc = __webpack_require__(25)
	var crossFade = __webpack_require__(27)
	var cursor = __webpack_require__(28)
	var filter = __webpack_require__(29)
	var flex = __webpack_require__(30)
	var flexboxIE = __webpack_require__(31)
	var flexboxOld = __webpack_require__(32)
	var gradient = __webpack_require__(33)
	var imageSet = __webpack_require__(34)
	var position = __webpack_require__(35)
	var sizing = __webpack_require__(36)
	var transition = __webpack_require__(37)
	
	module.exports =  {
	  plugins: [calc,crossFade,cursor,filter,flex,flexboxIE,flexboxOld,gradient,imageSet,position,sizing,transition],
	  prefixMap: {"transform":["Webkit","ms"],"transformOrigin":["Webkit","ms"],"transformOriginX":["Webkit","ms"],"transformOriginY":["Webkit","ms"],"backfaceVisibility":["Webkit"],"perspective":["Webkit"],"perspectiveOrigin":["Webkit"],"transformStyle":["Webkit"],"transformOriginZ":["Webkit"],"animation":["Webkit"],"animationDelay":["Webkit"],"animationDirection":["Webkit"],"animationFillMode":["Webkit"],"animationDuration":["Webkit"],"animationIterationCount":["Webkit"],"animationName":["Webkit"],"animationPlayState":["Webkit"],"animationTimingFunction":["Webkit"],"appearance":["Webkit","Moz"],"userSelect":["Webkit","Moz","ms"],"fontKerning":["Webkit"],"textEmphasisPosition":["Webkit"],"textEmphasis":["Webkit"],"textEmphasisStyle":["Webkit"],"textEmphasisColor":["Webkit"],"boxDecorationBreak":["Webkit"],"clipPath":["Webkit"],"maskImage":["Webkit"],"maskMode":["Webkit"],"maskRepeat":["Webkit"],"maskPosition":["Webkit"],"maskClip":["Webkit"],"maskOrigin":["Webkit"],"maskSize":["Webkit"],"maskComposite":["Webkit"],"mask":["Webkit"],"maskBorderSource":["Webkit"],"maskBorderMode":["Webkit"],"maskBorderSlice":["Webkit"],"maskBorderWidth":["Webkit"],"maskBorderOutset":["Webkit"],"maskBorderRepeat":["Webkit"],"maskBorder":["Webkit"],"maskType":["Webkit"],"textDecorationStyle":["Webkit","Moz"],"textDecorationSkip":["Webkit","Moz"],"textDecorationLine":["Webkit","Moz"],"textDecorationColor":["Webkit","Moz"],"filter":["Webkit"],"fontFeatureSettings":["Webkit","Moz"],"breakAfter":["Webkit","Moz","ms"],"breakBefore":["Webkit","Moz","ms"],"breakInside":["Webkit","Moz","ms"],"columnCount":["Webkit","Moz"],"columnFill":["Webkit","Moz"],"columnGap":["Webkit","Moz"],"columnRule":["Webkit","Moz"],"columnRuleColor":["Webkit","Moz"],"columnRuleStyle":["Webkit","Moz"],"columnRuleWidth":["Webkit","Moz"],"columns":["Webkit","Moz"],"columnSpan":["Webkit","Moz"],"columnWidth":["Webkit","Moz"],"flex":["Webkit","ms"],"flexBasis":["Webkit"],"flexDirection":["Webkit","ms"],"flexGrow":["Webkit"],"flexFlow":["Webkit","ms"],"flexShrink":["Webkit"],"flexWrap":["Webkit","ms"],"alignContent":["Webkit"],"alignItems":["Webkit"],"alignSelf":["Webkit"],"justifyContent":["Webkit"],"order":["Webkit"],"transitionDelay":["Webkit"],"transitionDuration":["Webkit"],"transitionProperty":["Webkit"],"transitionTimingFunction":["Webkit"],"backdropFilter":["Webkit"],"scrollSnapType":["Webkit","ms"],"scrollSnapPointsX":["Webkit","ms"],"scrollSnapPointsY":["Webkit","ms"],"scrollSnapDestination":["Webkit","ms"],"scrollSnapCoordinate":["Webkit","ms"],"shapeImageThreshold":["Webkit"],"shapeImageMargin":["Webkit"],"shapeImageOutside":["Webkit"],"hyphens":["Webkit","Moz","ms"],"flowInto":["Webkit","ms"],"flowFrom":["Webkit","ms"],"regionFragment":["Webkit","ms"],"boxSizing":["Moz"],"textAlignLast":["Moz"],"tabSize":["Moz"],"wrapFlow":["ms"],"wrapThrough":["ms"],"wrapMargin":["ms"],"touchAction":["ms"],"gridTemplateColumns":["ms"],"gridTemplateRows":["ms"],"gridTemplateAreas":["ms"],"gridTemplate":["ms"],"gridAutoColumns":["ms"],"gridAutoRows":["ms"],"gridAutoFlow":["ms"],"grid":["ms"],"gridRowStart":["ms"],"gridColumnStart":["ms"],"gridRowEnd":["ms"],"gridRow":["ms"],"gridColumn":["ms"],"gridColumnEnd":["ms"],"gridColumnGap":["ms"],"gridRowGap":["ms"],"gridArea":["ms"],"gridGap":["ms"],"textSizeAdjust":["Webkit","ms"],"borderImage":["Webkit"],"borderImageOutset":["Webkit"],"borderImageRepeat":["Webkit"],"borderImageSlice":["Webkit"],"borderImageSource":["Webkit"],"borderImageWidth":["Webkit"]}
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(38);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(26);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(20);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(39);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var MAP_EXISTS = typeof Map !== 'undefined';
	
	var OrderedElements = (function () {
	    /* ::
	    elements: {[string]: any};
	    keyOrder: string[];
	    */
	
	    function OrderedElements() {
	        _classCallCheck(this, OrderedElements);
	
	        this.elements = {};
	        this.keyOrder = [];
	    }
	
	    _createClass(OrderedElements, [{
	        key: 'forEach',
	        value: function forEach(callback /* : (string, any) => void */) {
	            for (var i = 0; i < this.keyOrder.length; i++) {
	                // (value, key) to match Map's API
	                callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
	            }
	        }
	    }, {
	        key: 'set',
	        value: function set(key, /* : string */value, /* : any */shouldReorder /* : ?boolean */) {
	            var _this = this;
	
	            if (!this.elements.hasOwnProperty(key)) {
	                this.keyOrder.push(key);
	            } else if (shouldReorder) {
	                var index = this.keyOrder.indexOf(key);
	                this.keyOrder.splice(index, 1);
	                this.keyOrder.push(key);
	            }
	
	            if (value == null) {
	                this.elements[key] = value;
	                return;
	            }
	
	            if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
	                var _ret = (function () {
	                    // We have found a nested Map, so we need to recurse so that all
	                    // of the nested objects and Maps are merged properly.
	                    var nested = _this.elements.hasOwnProperty(key) ? _this.elements[key] : new OrderedElements();
	                    value.forEach(function (value, key) {
	                        nested.set(key, value, shouldReorder);
	                    });
	                    _this.elements[key] = nested;
	                    return {
	                        v: undefined
	                    };
	                })();
	
	                if (typeof _ret === 'object') return _ret.v;
	            }
	
	            if (!Array.isArray(value) && typeof value === 'object') {
	                // We have found a nested object, so we need to recurse so that all
	                // of the nested objects and Maps are merged properly.
	                var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
	                var keys = Object.keys(value);
	                for (var i = 0; i < keys.length; i += 1) {
	                    nested.set(keys[i], value[keys[i]], shouldReorder);
	                }
	                this.elements[key] = nested;
	                return;
	            }
	
	            this.elements[key] = value;
	        }
	    }, {
	        key: 'get',
	        value: function get(key /* : string */) /* : any */{
	            return this.elements[key];
	        }
	    }, {
	        key: 'has',
	        value: function has(key /* : string */) /* : boolean */{
	            return this.elements.hasOwnProperty(key);
	        }
	    }, {
	        key: 'addStyleType',
	        value: function addStyleType(styleType /* : any */) /* : void */{
	            var _this2 = this;
	
	            if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
	                styleType.forEach(function (value, key) {
	                    _this2.set(key, value, true);
	                });
	            } else {
	                var keys = Object.keys(styleType);
	                for (var i = 0; i < keys.length; i++) {
	                    this.set(keys[i], styleType[keys[i]], true);
	                }
	            }
	        }
	    }]);
	
	    return OrderedElements;
	})();
	
	exports['default'] = OrderedElements;
	module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stringHash = __webpack_require__(42);
	
	var _stringHash2 = _interopRequireDefault(_stringHash);
	
	/* ::
	type Pair = [ string, any ];
	type Pairs = Pair[];
	type PairsMapper = (pair: Pair) => Pair;
	type ObjectMap = { [id:string]: any };
	*/
	
	var mapObj = function mapObj(obj, /* : ObjectMap */
	fn /* : PairsMapper */
	) /* : ObjectMap */{
	    var keys = Object.keys(obj);
	    var mappedObj = {};
	    for (var i = 0; i < keys.length; i += 1) {
	        var _fn = fn([keys[i], obj[keys[i]]]);
	
	        var _fn2 = _slicedToArray(_fn, 2);
	
	        var newKey = _fn2[0];
	        var newValue = _fn2[1];
	
	        mappedObj[newKey] = newValue;
	    }
	    return mappedObj;
	};
	
	exports.mapObj = mapObj;
	var UPPERCASE_RE = /([A-Z])/g;
	var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match /* : string */) {
	    return (/* : string */'-' + match.toLowerCase()
	    );
	};
	
	var kebabifyStyleName = function kebabifyStyleName(string /* : string */) /* : string */{
	    var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);
	    if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
	        return '-' + result;
	    }
	    return result;
	};
	
	exports.kebabifyStyleName = kebabifyStyleName;
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Taken from React's CSSProperty.js
	 */
	var isUnitlessNumber = {
	    animationIterationCount: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridRow: true,
	    gridColumn: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	
	    // SVG-related properties
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	};
	
	/**
	 * Taken from React's CSSProperty.js
	 *
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 * Taken from React's CSSProperty.js
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	// Taken from React's CSSProperty.js
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	    });
	});
	
	var stringifyValue = function stringifyValue(key, /* : string */
	prop /* : any */
	) /* : string */{
	    if (typeof prop === "number") {
	        if (isUnitlessNumber[key]) {
	            return "" + prop;
	        } else {
	            return prop + "px";
	        }
	    } else {
	        return '' + prop;
	    }
	};
	
	exports.stringifyValue = stringifyValue;
	var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key, /* : string */
	prop /* : any */
	) {
	    return (/* : string */importantify(stringifyValue(key, prop))
	    );
	};
	
	exports.stringifyAndImportantifyValue = stringifyAndImportantifyValue;
	// Turn a string into a hash string of base-36 values (using letters and numbers)
	var hashString = function hashString(string /* : string */) {
	    return (/* string */(0, _stringHash2['default'])(string).toString(36)
	    );
	};
	
	exports.hashString = hashString;
	// Hash a javascript object using JSON.stringify. This is very fast, about 3
	// microseconds on my computer for a sample object:
	// http://jsperf.com/test-hashfnv32a-hash/5
	//
	// Note that this uses JSON.stringify to stringify the objects so in order for
	// this to produce consistent hashes browsers need to have a consistent
	// ordering of objects. Ben Alpert says that Facebook depends on this, so we
	// can probably depend on this too.
	var hashObject = function hashObject(object /* : ObjectMap */) {
	    return (/* : string */hashString(JSON.stringify(object))
	    );
	};
	
	exports.hashObject = hashObject;
	// Given a single style value string like the "b" from "a: b;", adds !important
	// to generate "b !important".
	var importantify = function importantify(string /* : string */) {
	    return (/* : string */
	        // Bracket string character access is very fast, and in the default case we
	        // normally don't expect there to be "!important" at the end of the string
	        // so we can use this simple check to take an optimized path. If there
	        // happens to be a "!" in this position, we follow up with a more thorough
	        // check.
	        string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : string + ' !important'
	    );
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	
	function hash(str) {
	  var hash = 5381,
	      i    = str.length;
	
	  while(i) {
	    hash = (hash * 33) ^ str.charCodeAt(--i);
	  }
	
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	   * integers. Since we want the results to be always positive, convert the
	   * signed int to an unsigned by doing an unsigned bitshift. */
	  return hash >>> 0;
	}
	
	module.exports = hash;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(41);
	
	var _inject = __webpack_require__(45);
	
	/* ::
	import type { SelectorHandler } from './generate.js';
	export type SheetDefinition = { [id:string]: any };
	export type SheetDefinitions = SheetDefinition | SheetDefinition[];
	type RenderFunction = () => string;
	type Extension = {
	    selectorHandler: SelectorHandler
	};
	export type MaybeSheetDefinition = SheetDefinition | false | null | void
	*/
	
	var StyleSheet = {
	    create: function create(sheetDefinition /* : SheetDefinition */) {
	        return (0, _util.mapObj)(sheetDefinition, function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2);
	
	            var key = _ref2[0];
	            var val = _ref2[1];
	
	            var stringVal = JSON.stringify(val);
	            return [key, {
	                _len: stringVal.length,
	                _name: process.env.NODE_ENV === 'production' ? (0, _util.hashString)(stringVal) : key + '_' + (0, _util.hashString)(stringVal),
	                _definition: val
	            }];
	        });
	    },
	
	    rehydrate: function rehydrate() {
	        var renderedClassNames /* : string[] */ = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	        (0, _inject.addRenderedClassNames)(renderedClassNames);
	    }
	};
	
	/**
	 * Utilities for using Aphrodite server-side.
	 */
	var StyleSheetServer = {
	    renderStatic: function renderStatic(renderFunc /* : RenderFunction */) {
	        (0, _inject.reset)();
	        (0, _inject.startBuffering)();
	        var html = renderFunc();
	        var cssContent = (0, _inject.flushToString)();
	
	        return {
	            html: html,
	            css: {
	                content: cssContent,
	                renderedClassNames: (0, _inject.getRenderedClassNames)()
	            }
	        };
	    }
	};
	
	/**
	 * Utilities for using Aphrodite in tests.
	 *
	 * Not meant to be used in production.
	 */
	var StyleSheetTestUtils = {
	    /**
	     * Prevent styles from being injected into the DOM.
	     *
	     * This is useful in situations where you'd like to test rendering UI
	     * components which use Aphrodite without any of the side-effects of
	     * Aphrodite happening. Particularly useful for testing the output of
	     * components when you have no DOM, e.g. testing in Node without a fake DOM.
	     *
	     * Should be paired with a subsequent call to
	     * clearBufferAndResumeStyleInjection.
	     */
	    suppressStyleInjection: function suppressStyleInjection() {
	        (0, _inject.reset)();
	        (0, _inject.startBuffering)();
	    },
	
	    /**
	     * Opposite method of preventStyleInject.
	     */
	    clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
	        (0, _inject.reset)();
	    }
	};
	
	/**
	 * Generate the Aphrodite API exports, with given `selectorHandlers` and
	 * `useImportant` state.
	 */
	var makeExports = function makeExports(useImportant, /* : boolean */
	selectorHandlers /* : SelectorHandler[] */
	) {
	    return {
	        StyleSheet: _extends({}, StyleSheet, {
	
	            /**
	             * Returns a version of the exports of Aphrodite (i.e. an object
	             * with `css` and `StyleSheet` properties) which have some
	             * extensions included.
	             *
	             * @param {Array.<Object>} extensions: An array of extensions to
	             *     add to this instance of Aphrodite. Each object should have a
	             *     single property on it, defining which kind of extension to
	             *     add.
	             * @param {SelectorHandler} [extensions[].selectorHandler]: A
	             *     selector handler extension. See `defaultSelectorHandlers` in
	             *     generate.js.
	             *
	             * @returns {Object} An object containing the exports of the new
	             *     instance of Aphrodite.
	             */
	            extend: function extend(extensions /* : Extension[] */) {
	                var extensionSelectorHandlers = extensions
	                // Pull out extensions with a selectorHandler property
	                .map(function (extension) {
	                    return extension.selectorHandler;
	                })
	                // Remove nulls (i.e. extensions without a selectorHandler
	                // property).
	                .filter(function (handler) {
	                    return handler;
	                });
	
	                return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
	            }
	        }),
	
	        StyleSheetServer: StyleSheetServer,
	        StyleSheetTestUtils: StyleSheetTestUtils,
	
	        css: function css() /* : MaybeSheetDefinition[] */{
	            for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
	                styleDefinitions[_key] = arguments[_key];
	            }
	
	            return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions, selectorHandlers);
	        }
	    };
	};
	
	module.exports = makeExports;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _asap = __webpack_require__(46);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _orderedElements = __webpack_require__(40);
	
	var _orderedElements2 = _interopRequireDefault(_orderedElements);
	
	var _generate = __webpack_require__(17);
	
	var _util = __webpack_require__(41);
	
	/* ::
	import type { SheetDefinition, SheetDefinitions } from './index.js';
	import type { MaybeSheetDefinition } from './exports.js';
	import type { SelectorHandler } from './generate.js';
	type ProcessedStyleDefinitions = {
	  classNameBits: Array<string>,
	  definitionBits: Array<Object>,
	};
	*/
	
	// The current <style> tag we are inserting into, or null if we haven't
	// inserted anything yet. We could find this each time using
	// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
	// faster.
	var styleTag = null;
	
	// Inject a string of styles into a <style> tag in the head of the document. This
	// will automatically create a style tag and then continue to use it for
	// multiple injections. It will also use a style tag with the `data-aphrodite`
	// tag on it if that exists in the DOM. This could be used for e.g. reusing the
	// same style tag that server-side rendering inserts.
	var injectStyleTag = function injectStyleTag(cssContents /* : string */) {
	    if (styleTag == null) {
	        // Try to find a style tag with the `data-aphrodite` attribute first.
	        styleTag = document.querySelector("style[data-aphrodite]");
	
	        // If that doesn't work, generate a new style tag.
	        if (styleTag == null) {
	            // Taken from
	            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
	            var head = document.head || document.getElementsByTagName('head')[0];
	            styleTag = document.createElement('style');
	
	            styleTag.type = 'text/css';
	            styleTag.setAttribute("data-aphrodite", "");
	            head.appendChild(styleTag);
	        }
	    }
	
	    if (styleTag.styleSheet) {
	        // $FlowFixMe: legacy Internet Explorer compatibility
	        styleTag.styleSheet.cssText += cssContents;
	    } else {
	        styleTag.appendChild(document.createTextNode(cssContents));
	    }
	};
	
	// Custom handlers for stringifying CSS values that have side effects
	// (such as fontFamily, which can cause @font-face rules to be injected)
	var stringHandlers = {
	    // With fontFamily we look for objects that are passed in and interpret
	    // them as @font-face rules that we need to inject. The value of fontFamily
	    // can either be a string (as normal), an object (a single font face), or
	    // an array of objects and strings.
	    fontFamily: function fontFamily(val) {
	        if (Array.isArray(val)) {
	            return val.map(fontFamily).join(",");
	        } else if (typeof val === "object") {
	            injectStyleOnce(val.src, "@font-face", [val], false);
	            return '"' + val.fontFamily + '"';
	        } else {
	            return val;
	        }
	    },
	
	    // With animationName we look for an object that contains keyframes and
	    // inject them as an `@keyframes` block, returning a uniquely generated
	    // name. The keyframes object should look like
	    //  animationName: {
	    //    from: {
	    //      left: 0,
	    //      top: 0,
	    //    },
	    //    '50%': {
	    //      left: 15,
	    //      top: 5,
	    //    },
	    //    to: {
	    //      left: 20,
	    //      top: 20,
	    //    }
	    //  }
	    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
	    // to use `animationName` here. Improve that so we can call this
	    // `animation` instead of `animationName`.
	    animationName: function animationName(val, selectorHandlers) {
	        if (Array.isArray(val)) {
	            return val.map(function (v) {
	                return animationName(v, selectorHandlers);
	            }).join(",");
	        } else if (typeof val === "object") {
	            // Generate a unique name based on the hash of the object. We can't
	            // just use the hash because the name can't start with a number.
	            // TODO(emily): this probably makes debugging hard, allow a custom
	            // name?
	            var _name = 'keyframe_' + (0, _util.hashObject)(val);
	
	            // Since keyframes need 3 layers of nesting, we use `generateCSS` to
	            // build the inner layers and wrap it in `@keyframes` ourselves.
	            var finalVal = '@keyframes ' + _name + '{';
	
	            // TODO see if we can find a way where checking for OrderedElements
	            // here is not necessary. Alternatively, perhaps we should have a
	            // utility method that can iterate over either a plain object, an
	            // instance of OrderedElements, or a Map, and then use that here and
	            // elsewhere.
	            if (val instanceof _orderedElements2['default']) {
	                val.forEach(function (valVal, valKey) {
	                    finalVal += (0, _generate.generateCSS)(valKey, [valVal], selectorHandlers, stringHandlers, false);
	                });
	            } else {
	                Object.keys(val).forEach(function (key) {
	                    finalVal += (0, _generate.generateCSS)(key, [val[key]], selectorHandlers, stringHandlers, false);
	                });
	            }
	            finalVal += '}';
	
	            injectGeneratedCSSOnce(_name, finalVal);
	
	            return _name;
	        } else {
	            return val;
	        }
	    }
	};
	
	// This is a map from Aphrodite's generated class names to `true` (acting as a
	// set of class names)
	var alreadyInjected = {};
	
	// This is the buffer of styles which have not yet been flushed.
	var injectionBuffer = "";
	
	// A flag to tell if we are already buffering styles. This could happen either
	// because we scheduled a flush call already, so newly added styles will
	// already be flushed, or because we are statically buffering on the server.
	var isBuffering = false;
	
	var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
	    if (alreadyInjected[key]) {
	        return;
	    }
	
	    if (!isBuffering) {
	        // We should never be automatically buffering on the server (or any
	        // place without a document), so guard against that.
	        if (typeof document === "undefined") {
	            throw new Error("Cannot automatically buffer without a document");
	        }
	
	        // If we're not already buffering, schedule a call to flush the
	        // current styles.
	        isBuffering = true;
	        (0, _asap2['default'])(flushToStyleTag);
	    }
	
	    injectionBuffer += generatedCSS;
	    alreadyInjected[key] = true;
	};
	
	var injectStyleOnce = function injectStyleOnce(key, /* : string */
	selector, /* : string */
	definitions, /* : SheetDefinition[] */
	useImportant /* : boolean */
	) {
	    var selectorHandlers /* : SelectorHandler[] */ = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	
	    if (alreadyInjected[key]) {
	        return;
	    }
	
	    var generated = (0, _generate.generateCSS)(selector, definitions, selectorHandlers, stringHandlers, useImportant);
	
	    injectGeneratedCSSOnce(key, generated);
	};
	
	exports.injectStyleOnce = injectStyleOnce;
	var reset = function reset() {
	    injectionBuffer = "";
	    alreadyInjected = {};
	    isBuffering = false;
	    styleTag = null;
	};
	
	exports.reset = reset;
	var startBuffering = function startBuffering() {
	    if (isBuffering) {
	        throw new Error("Cannot buffer while already buffering");
	    }
	    isBuffering = true;
	};
	
	exports.startBuffering = startBuffering;
	var flushToString = function flushToString() {
	    isBuffering = false;
	    var ret = injectionBuffer;
	    injectionBuffer = "";
	    return ret;
	};
	
	exports.flushToString = flushToString;
	var flushToStyleTag = function flushToStyleTag() {
	    var cssContent = flushToString();
	    if (cssContent.length > 0) {
	        injectStyleTag(cssContent);
	    }
	};
	
	exports.flushToStyleTag = flushToStyleTag;
	var getRenderedClassNames = function getRenderedClassNames() {
	    return Object.keys(alreadyInjected);
	};
	
	exports.getRenderedClassNames = getRenderedClassNames;
	var addRenderedClassNames = function addRenderedClassNames(classNames /* : string[] */) {
	    classNames.forEach(function (className) {
	        alreadyInjected[className] = true;
	    });
	};
	
	exports.addRenderedClassNames = addRenderedClassNames;
	var processStyleDefinitions = function processStyleDefinitions(styleDefinitions, /* : any[] */
	result /* : ProcessedStyleDefinitions */
	) /* : void */{
	    for (var i = 0; i < styleDefinitions.length; i += 1) {
	        // Filter out falsy values from the input, to allow for
	        // `css(a, test && c)`
	        if (styleDefinitions[i]) {
	            if (Array.isArray(styleDefinitions[i])) {
	                // We've encountered an array, so let's recurse
	                processStyleDefinitions(styleDefinitions[i], result);
	            } else {
	                result.classNameBits.push(styleDefinitions[i]._name);
	                result.definitionBits.push(styleDefinitions[i]._definition);
	            }
	        }
	    }
	};
	
	// Sum up the lengths of the stringified style definitions (which was saved as _len property)
	// and use modulus to return a single byte hash value.
	// We append this extra byte to the 32bit hash to decrease the chance of hash collisions.
	var getStyleDefinitionsLengthHash = function getStyleDefinitionsLengthHash(styleDefinitions /* : any[] */) {
	    return (/* : string */(styleDefinitions.reduce(function (length, styleDefinition) {
	            return length + (styleDefinition ? styleDefinition._len : 0);
	        }, 0) % 36).toString(36)
	    );
	};
	
	/**
	 * Inject styles associated with the passed style definition objects, and return
	 * an associated CSS class name.
	 *
	 * @param {boolean} useImportant If true, will append !important to generated
	 *     CSS output. e.g. {color: red} -> "color: red !important".
	 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
	 *     arbitrarily nested arrays of them, as returned as properties of the
	 *     return value of StyleSheet.create().
	 */
	var injectAndGetClassName = function injectAndGetClassName(useImportant, /* : boolean */
	styleDefinitions, /* : MaybeSheetDefinition[] */
	selectorHandlers /* : SelectorHandler[] */
	) /* : string */{
	    var processedStyleDefinitions /* : ProcessedStyleDefinitions */ = {
	        classNameBits: [],
	        definitionBits: []
	    };
	    // Mutates processedStyleDefinitions
	    processStyleDefinitions(styleDefinitions, processedStyleDefinitions);
	
	    // Break if there aren't any valid styles.
	    if (processedStyleDefinitions.classNameBits.length === 0) {
	        return "";
	    }
	
	    var className = undefined;
	    if (process.env.NODE_ENV === 'production') {
	        className = processedStyleDefinitions.classNameBits.length === 1 ? '_' + processedStyleDefinitions.classNameBits[0] : '_' + (0, _util.hashString)(processedStyleDefinitions.classNameBits.join()) + getStyleDefinitionsLengthHash(styleDefinitions);
	    } else {
	        className = processedStyleDefinitions.classNameBits.join("-o_O-");
	    }
	
	    injectStyleOnce(className, '.' + className, processedStyleDefinitions.definitionBits, useImportant, selectorHandlers);
	
	    return className;
	};
	exports.injectAndGetClassName = injectAndGetClassName;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(44)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(47);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getParam = getParam;
	exports.reformatReleaseUrl = reformatReleaseUrl;
	function getParam(str, key) {
	    var regexS = "[\\?&]" + key + "=([^&#]*)";
	    var regex = new RegExp(regexS);
	    var results = regex.exec(str);
	    if (results == null) {
	        return "";
	    } else {
	        return results[1];
	    }
	}
	
	/**
	 * reformats the release url to a jw player supported release url
	 */
	function reformatReleaseUrl(releaseUrl) {
	    //constructing new release url format
	    var releaseId = releaseUrl.match(/BKQ29B\/(.*?)\?/)[1];
	    return releaseUrl = "https://link.theplatform.com/s/BKQ29B/" + releaseId + "?formats=m3u";
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FsPlayer = __webpack_require__(13);
	
	var _FsPlayer2 = _interopRequireDefault(_FsPlayer);
	
	var _VideoPlaylistItem = __webpack_require__(50);
	
	var _VideoPlaylistItem2 = _interopRequireDefault(_VideoPlaylistItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _VideoPlaylistStyles = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPlaylist = function (_React$Component) {
	    _inherits(VideoPlaylist, _React$Component);
	
	    function VideoPlaylist(props) {
	        _classCallCheck(this, VideoPlaylist);
	
	        var _this = _possibleConstructorReturn(this, (VideoPlaylist.__proto__ || Object.getPrototypeOf(VideoPlaylist)).call(this, props));
	
	        _this.title = _this.props.title;
	        _this.hideTitle = _this.props.hideTitle && !_this.title || false;
	        var videos = _this.props.videos || [];
	        _this.state = {
	            activeIndex: _this.props.upNext,
	            skipFirst: _this.props.skipFirst || false, //we want to skip the first item when this is used by VideoPlayer react Component
	            videos: videos
	        };
	
	        //passing the callback which returns the post the user clicks on 
	        _this.updateCurrentPost = _this.props.onClick;
	
	        //callback to the //VideoPlayer.js to set active state 
	        _this.setActiveState = _this.props.setActiveState;
	
	        _this.updateDetails = function (e) {
	            return _this.props.showDetails && _this.props.showDetails(e);
	        };
	
	        return _this;
	    }
	
	    _createClass(VideoPlaylist, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.cont.addEventListener('scroll', this.updateDetails);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.cont.removeEventListener('scroll', this.updateDetails);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var videos = this.state.videos;
	            var activeItem = this.props.upNext;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(elem) {
	                        return _this2.cont = elem;
	                    }, className: (0, _noImportant.css)(_VideoPlaylistStyles.styles.playlistCont) + " playlist-container" },
	                !this.hideTitle && _react2.default.createElement(
	                    'h3',
	                    { className: (0, _noImportant.css)(_VideoPlaylistStyles.styles.compTitle) },
	                    ' ',
	                    this.title,
	                    ' '
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "vm-more-videos" },
	                    videos ? videos.map(function (item, index) {
	                        if (_this2.state.skipFirst) {
	                            if (index != 0) {
	                                return _react2.default.createElement(_VideoPlaylistItem2.default, { post: item, index: index, activeItem: activeItem, setActiveState: _this2.setActiveState, onClick: _this2.updateCurrentPost });
	                            }
	                        } else {
	                            return _react2.default.createElement(_VideoPlaylistItem2.default, { post: item, index: index, activeItem: activeItem, setActiveState: _this2.setActiveState, onClick: _this2.updateCurrentPost });
	                        }
	                    }) : _react2.default.createElement('div', null),
	                    this.props.enableShowMore && _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', className: (0, _noImportant.css)(_VideoPlaylistStyles.styles.showMore) },
	                        '  '
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoPlaylist;
	}(_react2.default.Component);
	
	exports.default = VideoPlaylist;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(51);
	
	var _VideoPlaylistItemStyles = __webpack_require__(54);
	
	var _noImportant = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoPlaylistItem = function (_React$Component) {
	    _inherits(VideoPlaylistItem, _React$Component);
	
	    function VideoPlaylistItem(props) {
	        _classCallCheck(this, VideoPlaylistItem);
	
	        var _this = _possibleConstructorReturn(this, (VideoPlaylistItem.__proto__ || Object.getPrototypeOf(VideoPlaylistItem)).call(this, props));
	
	        _this.state = { videoHover: false };
	        _this.post = _this.props.post || {};
	        _this.toggleVideoHover = _this.toggleVideoHover.bind(_this);
	        _this.updateCurrentPost = function (e) {
	            e.preventDefault();
	            //set active state 
	            if (_this.props.setActiveState) {
	                _this.props.setActiveState(_this.props.index + 1);
	            }
	            _this.props.onClick(_this.post);
	        };
	        return _this;
	    }
	
	    /**
	     * toggles video hover state
	     */
	
	
	    _createClass(VideoPlaylistItem, [{
	        key: 'toggleVideoHover',
	        value: function toggleVideoHover() {
	            this.setState({ videoHover: !this.state.videoHover });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.post;
	            var titleStyles = [_VideoPlaylistItemStyles.styles.thumbTitle];
	            var nowPlayingStyles = [_icons.icons.icNowPlaying];
	            var thumbOverlayStyles = [_VideoPlaylistItemStyles.styles.thumbOverlay];
	
	            var isActive = this.props.index === this.props.activeItem;
	
	            var playBtnStyles = [_icons.playIcon.icPlayTiny, _VideoPlaylistItemStyles.styles.zIndexOne];
	
	            if (this.state.videoHover) {
	                playBtnStyles.push(_icons.playIcon.icPlayHover);
	            }
	
	            return _react2.default.createElement(
	                'a',
	                { href: this.post.videoUrl, className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.videoTplCont) + ' more-thumb-link', onClick: this.updateCurrentPost, 'data-release-url': post.releaseUrl,
	                    onMouseEnter: this.toggleVideoHover, onMouseLeave: this.toggleVideoHover },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.videoThumb) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.imgOverlay) },
	                        _react2.default.createElement('img', { src: post.thumb, className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.imgThumb) }),
	                        _react2.default.createElement(
	                            'span',
	                            { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.playCont) },
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.playIcon) + ' play-icon_vc' },
	                                _react2.default.createElement('span', { className: (0, _noImportant.css)(playBtnStyles) + ' play-dtn_vc' }),
	                                post.duration && _react2.default.createElement(
	                                    'span',
	                                    { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.durationContainer) },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.duration) },
	                                        post.duration
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _noImportant.css)(_VideoPlaylistItemStyles.styles.meta) },
	                    isActive && _react2.default.createElement(
	                        'span',
	                        { className: (0, _noImportant.css)(_icons.icons.icUpNext) },
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: (0, _noImportant.css)(titleStyles) },
	                        ' ',
	                        post.title,
	                        ' '
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoPlaylistItem;
	}(_react2.default.Component);
	
	exports.default = VideoPlaylistItem;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.foxSportsAppIcon = exports.keyIcon = exports.fsgoIcon = exports.liveIcon = exports.shareIcons = exports.icons = exports.playIcon = undefined;
	
	var _icShare;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var playIcon = exports.playIcon = _noImportant.StyleSheet.create({
		icPlay: generatePlayIconStyleObj(_vars.iconUrl.icPlayMed, '45px'),
		icPlayBig: generatePlayIconStyleObj(_vars.iconUrl.icPlayMed, '68px'),
		icPlayTiny: generatePlayIconStyleObj(_vars.iconUrl.icPlayTiny, '25px'),
		icPlayHover: {
			backgroundColor: _vars.color.black,
			transform: 'scale(1.05)'
		}
	});
	
	var icons = exports.icons = _noImportant.StyleSheet.create({
	
		icCloseIconWhite: {
			background: 'url(' + _vars.iconUrl.closeIconWhite + ')',
			display: 'block',
			width: '18px',
			height: '18px'
		},
	
		icUpNext: {
			background: 'url(' + _vars.iconUrl.upNext + ')',
			display: 'block',
			width: '64px',
			height: '13px',
			marginBottom: '5px',
			backgroundSize: 64
		},
	
		icFs: {
			background: 'url(' + _vars.iconUrl.fsWhite + ')',
			display: 'block',
			backgroundSize: '59px',
			width: '59px',
			height: '35px'
		}
	});
	
	var shareIcons = exports.shareIcons = _noImportant.StyleSheet.create({
		inlineContainer: {
			display: 'inline-flex',
			marginBottom: '20px'
		},
	
		icLinkShare: generateIcShareStyleObj(_vars.iconUrl.icUrlLink, { border: 'none', outline: 'none' }),
	
		icWhatsappShare: {
			display: 'block',
			background: 'url(' + _vars.iconUrl.icWhatsapp + ')',
			backgroundSize: '100%',
			height: '100%'
		},
		icSmsShare: {
			display: 'block',
			background: 'url(' + _vars.iconUrl.icSms + ')',
			backgroundSize: '100%',
			height: '100%'
		},
	
		icFacebook: _defineProperty({
			display: 'block',
			background: 'url(' + _vars.iconUrl.icFBShareBig + ')',
			backgroundSize: '100%',
			height: '100%'
	
		}, _constants.media.MOBILE_OR_TABLET, {
			background: 'url(' + _vars.iconUrl.icFBShareSmall + ')',
			backgroundSize: '100%'
		}),
		icEmailShare: {
			display: 'block',
			background: 'url(' + _vars.iconUrl.icEmail + ')',
			backgroundSize: '100%',
			height: '100%'
		},
		icUrlShare: {
			display: 'block',
			background: 'url(' + _vars.iconUrl.icUrlLink + ')',
			backgroundSize: '100%',
			height: '100%'
		},
	
		icLink: {
			width: 19,
			height: 19
		},
	
		icFbBgColor: {
			backgroundColor: '#375399'
		},
		icLinkBgColor: {
			backgroundColor: '#0074ff'
		},
		icEmailBgColor: {
			backgroundColor: '#3e4755'
		},
	
		shareLabel: {
			fontFamily: 'Antenna',
			fontSize: '9px',
			fontWeight: 300,
			fontStyle: 'normal',
			fontStretch: 'normal',
			lineHeight: 'normal',
			letterSpacing: '2px',
			textAlign: 'left',
			color: _vars.color.white,
			paddingLeft: 10
		},
	
		icShare: (_icShare = {
			display: 'block',
			width: '90px',
			height: '38px'
		}, _defineProperty(_icShare, 'display', 'inline-flex'), _defineProperty(_icShare, 'alignItems', 'center'), _defineProperty(_icShare, 'textDecoration', 'none'), _defineProperty(_icShare, 'paddingLeft', 10), _defineProperty(_icShare, 'cursor', 'pointer'), _defineProperty(_icShare, _constants.media.MOBILE_OR_TABLET, {
			width: '78px',
			height: '33px'
		}), _icShare),
	
		icShareDefault: _defineProperty({
			display: 'block',
			width: '90px',
			height: '38px',
			position: 'relative'
		}, _constants.media.MOBILE_OR_TABLET, {
			width: '78px',
			height: '33px'
		}),
		icShareBtn: {
			padding: 0,
			marginTop: 0,
			border: 'none',
			background: 'none',
			outline: 'none'
		},
	
		icMarginLeft: {
			marginLeft: 10
		}
	
	});
	
	var liveIcon = exports.liveIcon = _noImportant.StyleSheet.create({
		icLive: {
			width: '29px',
			height: '13px',
			backgroundImage: 'url(' + _vars.iconUrl.icLive + ')',
			backgroundSize: '100%'
		}
	});
	
	var fsgoIcon = exports.fsgoIcon = _noImportant.StyleSheet.create({
		white: generateFsgoIconStyleObj(_vars.iconUrl.fsgoWhite),
		black: generateFsgoIconStyleObj(_vars.iconUrl.fsgoBlack)
	});
	
	var keyIcon = exports.keyIcon = _noImportant.StyleSheet.create({
		white: {
			width: '24px',
			height: '10px',
			backgroundImage: 'url(' + _vars.iconUrl.icKey + ')',
			backgroundSize: '100%',
			display: 'block'
		}
	});
	
	var foxSportsAppIcon = exports.foxSportsAppIcon = _noImportant.StyleSheet.create({
		base: _defineProperty({
			width: '40px',
			height: '40px',
			backgroundSize: '100% 100%',
			display: 'block'
	
		}, _constants.media.MOBILE, {
			width: '20px',
			height: '20px'
		}),
		small: _defineProperty({
			width: '30px',
			height: '30px'
	
		}, _constants.media.MOBILE, {
			width: '20px',
			height: '20px'
		}),
		dark: {
			backgroundImage: 'url(' + _vars.iconUrl.fsApp + ')'
		},
		light: {
			backgroundImage: 'url(' + _vars.iconUrl.fsApp + ')'
		}
	});
	
	/*
		Helpers for styles rendering
	 */
	
	function getBaseIconsStyle() {
		return {
			display: 'block',
			backgroundSize: '100%'
		};
	}
	
	function generatePlayIconStyleObj(url, size) {
		return Object.assign({}, getBaseIconsStyle(), {
			backgroundImage: 'url(' + url + ')',
			borderRadius: '50%',
			width: size,
			height: size
		});
	}
	
	function generateFsgoIconStyleObj(url) {
		return Object.assign({}, getBaseIconsStyle(), { height: '100%', backgroundImage: 'url(' + url + ')' });
	}
	
	function generateIcShareStyleObj(url, custom) {
		var base = {
			background: 'url(' + url + ')',
	
			':hover': {
				transform: 'scale(1.05)'
			}
		};
	
		return Object.assign({}, base, custom);
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.iconUrl = exports.fontWeight = exports.color = undefined;
	
	var _utils = __webpack_require__(8);
	
	var color = exports.color = {
		black: '#000000',
		dark: '#10151c',
		white: '#ffffff',
		gray: '#969696',
		semiLightGray: '#ddd9d3',
		lightGray: '#fafafa',
		darkGray: '#323232',
		fbBlue: '#4065b4',
		darkBlue: '#002e56',
		blue: '#0059b5',
		lightBlue: '#0076ff',
		pickledBluewood: '#2c394c',
		cobaltBlue: '#19202a',
		cobaltBlueLight: '#282f38',
		orange: '#ff7800',
		darkPurple: '#061751'
	};
	
	var fontWeight = exports.fontWeight = {
		bold: 700,
		semibold: 500,
		normal: 300,
		light: 200
	};
	
	var iconUrl = exports.iconUrl = {
		facebook: _utils.assetsDomain + 'images/facebook.svg',
		facebookShare: _utils.assetsDomain + 'images/ic-share-fb.svg',
		icPlayTiny: _utils.assetsDomain + 'images/ic-play-tiny.svg',
		icPlayMed: _utils.assetsDomain + 'images/ic-play-med.svg',
		upNext: _utils.assetsDomain + 'images/ic-upNext.png',
		closeIconWhite: _utils.assetsDomain + 'images/ic-close-white.svg',
		fsWhite: _utils.assetsDomain + 'images/ic-fs-white@2x.png',
		icLive: _utils.assetsDomain + 'images/ic-live@2x.png',
		fsgoWhite: _utils.assetsDomain + 'images/FoxSportsGO-white.svg',
		fsgoBlack: _utils.assetsDomain + 'images/FoxSportsGO.svg',
		icKey: _utils.assetsDomain + 'images/ic-key.svg',
		fsApp: _utils.assetsDomain + 'images/FoxSports_AppIcon.svg',
		fsAppDark: _utils.assetsDomain + 'images/FoxSports_AppIcon_Dark.svg',
		icFbWhite: _utils.assetsDomain + 'images/facebook-ico.png',
		icFBShareSmall: _utils.assetsDomain + 'images/ic-fbsmall.png',
		icFBShareBig: _utils.assetsDomain + 'images/ic-fbbig.png',
		icUrlLink: _utils.assetsDomain + 'images/ic-link-share.png',
		icEmail: _utils.assetsDomain + 'images/ic-email-share.png',
		icWhatsapp: _utils.assetsDomain + 'images/ic-whatsapp.png',
		icSms: _utils.assetsDomain + 'images/ic-sms.png'
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var media = exports.media = {
		DESKTOP: '@media (min-width: 1280px)',
		LAPTOP: '@media (min-width: 1024px) and (max-width: 1279px)',
		TABLET: '@media (min-width: 768px) and (max-width: 1023px)',
		MOBILE: '@media (max-width: 767px)',
		SMALL: '@media (max-width: 374px)',
	
		AT_LEAST_TABLET: '@media (min-width: 768px)',
		AT_LEAST_LAPTOP: '@media (min-width: 1024px)',
		MOBILE_OR_TABLET: '@media (max-width: 1023px)'
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = undefined;
	
	var _imgThumb;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = exports.styles = _noImportant.StyleSheet.create({
	    imgOverlay: {
	        position: 'relative'
	    },
	
	    playCont: {
	        display: 'inline-flex',
	        alignItems: 'center',
	        width: '100%',
	        height: '32px',
	        position: 'absolute',
	        bottom: 0
	    },
	
	    playIcon: {
	        bottom: '0',
	        width: '32px',
	        height: '32px',
	        display: 'inline-flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'absolute',
	        zIndex: 1
	    },
	
	    durationContainer: {
	        position: 'absolute',
	        left: 28,
	        height: 15,
	        display: 'block'
	    },
	    duration: {
	        backgroundColor: 'rgba(0, 0, 0, 0.75)',
	        height: '100%',
	        position: 'relative',
	        fontSize: '10px',
	        fontWeight: _vars.fontWeight.bold,
	        color: _vars.color.white,
	        paddingLeft: '6px',
	        paddingRight: '5px',
	        borderTopRightRadius: '2px',
	        borderBottomRightRadius: '2px',
	        display: 'block',
	
	        ':after': {
	            content: '""',
	            position: 'absolute',
	            width: '18px',
	            top: '0',
	            bottom: '0',
	            right: '100%',
	            backgroundColor: 'transparent',
	            borderTopRightRadius: '25% 11px',
	            borderBottomRightRadius: '25% 11px',
	            boxShadow: '14px 0px 0px 0px rgba(0, 0, 0, 0.75)',
	            clip: 'rect(0px, 18px, 18px, 0px)'
	        }
	    },
	
	    bkColor: {
	        backgroundColor: 'rgba(0,0,0,.7)'
	    },
	
	    videoLength: {
	        color: _vars.color.white,
	        fontFamily: 'Antenna',
	        fontSize: '10px',
	        fontWeight: _vars.fontWeight.bold,
	        lineHeight: .7,
	        backgroundColor: 'rgba(0,0,0,.7)',
	        borderRadius: '2px',
	        padding: '5px 5px 5px 8px',
	        display: 'inline-block',
	        position: 'absolute',
	        left: '24px',
	        zIndex: 0
	
	    },
	
	    videoTplCont: {
	        display: 'flex',
	        alignItems: 'center',
	        textDecoration: 'none',
	        position: 'relative',
	        marginBottom: '10px',
	        backgroundColor: _vars.color.cobaltBlueLight
	    },
	
	    thumbOverlay: {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        opacity: 0.05,
	        backgroundColor: _vars.color.lightGray,
	        zIndex: -1
	    },
	
	    thumbOverlayActive: {},
	
	    imgThumb: (_imgThumb = {
	        width: '150px',
	        maxHeight: '84px'
	
	    }, _defineProperty(_imgThumb, _constants.media.LAPTOP, {
	        width: 125,
	        height: 70
	    }), _defineProperty(_imgThumb, _constants.media.TABLET, {
	        width: 95,
	        height: 53
	    }), _defineProperty(_imgThumb, 'display', 'block'), _imgThumb),
	
	    meta: {
	        margin: '0 10px'
	    },
	
	    thumbTitle: {
	        fontFamily: 'Antenna',
	        fontSize: 11,
	        fontWeight: _vars.fontWeight.semibold,
	        lineHeight: 1.27,
	        textAlign: 'left',
	        marginTop: '4px',
	        color: _vars.color.white,
	        display: 'block'
	    },
	
	    thumbTitleActive: {
	        color: '#2c394c'
	    },
	
	    upNext: {
	        borderRadius: '2px',
	        backgroundColor: _vars.color.white,
	        color: _vars.color.pickledBluewood,
	        padding: '1px 4px',
	        fontFamily: 'Arial',
	        fontSize: '9px',
	        fontWeight: 'bold'
	    },
	    zIndexOne: {
	        zIndex: '1'
	    }
	});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = undefined;
	
	var _playlistCont;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = exports.styles = _noImportant.StyleSheet.create({
	
	    compTitle: {
	        fontFamily: 'Antenna',
	        fontSize: '13px',
	        fontWeight: _vars.fontWeight.semibold,
	        letterSpacing: '2px',
	        textAlign: 'center',
	        color: _vars.color.white,
	        marginTop: 0,
	        textTransform: 'uppercase'
	    },
	
	    divider: {
	        width: '100%',
	        height: '1px',
	        opacity: 0.1,
	        backgroundColor: _vars.color.white,
	        display: 'block',
	        margin: '20px 0'
	    },
	
	    playlistCont: (_playlistCont = {
	        width: '100%',
	        maxHeight: '88%',
	        overflowY: 'auto',
	        '::-webkit-scrollbar': {
	            display: 'none'
	        }
	
	    }, _defineProperty(_playlistCont, _constants.media.TABLET, {
	        maxHeight: '84%'
	    }), _defineProperty(_playlistCont, _constants.media.MOBILE, {
	        maxHeight: '300px',
	        '-webkit-overflow-scrolling': 'touch'
	    }), _playlistCont)
	
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(15);
	
	var _icons = __webpack_require__(51);
	
	var _constants = __webpack_require__(4);
	
	var _VideoShareStyles = __webpack_require__(57);
	
	var _Viewports = __webpack_require__(12);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _TrackingUtils = __webpack_require__(10);
	
	var _TrackingUtils2 = _interopRequireDefault(_TrackingUtils);
	
	var _Analytics = __webpack_require__(58);
	
	var _Analytics2 = _interopRequireDefault(_Analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoShare = function (_React$Component) {
	    _inherits(VideoShare, _React$Component);
	
	    function VideoShare(props) {
	        _classCallCheck(this, VideoShare);
	
	        var _this = _possibleConstructorReturn(this, (VideoShare.__proto__ || Object.getPrototypeOf(VideoShare)).call(this, props));
	
	        _this.state = {
	            url: _this.props.videoUrl,
	            videoUrl: encodeURIComponent(_this.props.videoUrl),
	            title: _this.props.title
	        };
	
	        _this.utmParam = "utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit";
	        _this.viewport = new _Viewports2.default();
	        _this.pageMeta = _Analytics2.default.getPageMeta();
	        _this.pageType = _this.pageMeta ? _this.pageMeta.page_type : 'post';
	        _this.utmTerm = _this.props.utmTerm ? _this.pageType + '_' + _this.props.utmTerm : _this.pageType;
	
	        _this.handleCopyToClipboard = function (e) {
	            var target = e.target.parentElement;
	            var textArea = target.parentElement.querySelector('.cpyLink');
	            textArea.select();
	            try {
	                document.execCommand('copy');
	            } catch (e) {
	                console.log('Oops, unable to copy', e.message);
	            }
	
	            target.setAttribute('data-social-tooltip', 'Copied to clipboard');
	
	            _this.trackShareLink(e);
	        };
	
	        _this.isMobile = _this.viewport.isTouch || _this.viewport.winW < 1024;
	        _this.isAndroid = _this.viewport.isAndroid;
	
	        _this.trackShareLink = _this.trackShareLink.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(VideoShare, [{
	        key: 'onMouseLeave',
	        value: function onMouseLeave(e) {
	            var target = e.target.parentElement;
	            target.removeAttribute('data-social-tooltip');
	        }
	    }, {
	        key: 'trackShareLink',
	        value: function trackShareLink(e) {
	
	            var utmSource = e.target.parentElement.getAttribute('data-share-type');
	            var utmTerm = this.utmTerm;
	            if (typeof window.utag !== "undefined") {
	
	                if (typeof PARSELY !== "undefined" && _typeof(PARSELY.beacon) === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
	                    var utmObj = {
	                        'utm_campaign': 'share_buttons',
	                        'utm_medium': 'fscom',
	                        'utm_source': 'share-' + utmSource,
	                        'utm_term': utmTerm,
	                        'utm_content': 'original_share'
	                    };
	
	                    var trackObj = {
	                        'url': _TrackingUtils2.default.addTrackingQuery(utmObj, this.state.url),
	                        js: 1 // flag indicating that this is a dynamic event, keep it "1"
	                    };
	
	                    PARSELY.beacon.trackPageView(trackObj);
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {}
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {}
	    }, {
	        key: 'render',
	        value: function render() {
	            var url = this.props.videoUrl;
	            var videoUrl = encodeURIComponent(this.props.videoUrl);
	            var title = this.props.title;
	            var utmParam = this.utmParam + '&utm_term=' + this.utmTerm;
	            var smsShare = videoUrl + '?' + encodeURIComponent(utmParam + '&utm_source=share_sms');
	            var shareStyles = [_icons.shareIcons.icMarginLeft, _icons.shareIcons.icShareDefault];
	            var sharedClassName = " share-btn";
	
	            this.shareLinks = {
	                fb: _constants.shareLinks.FB_SHARE + videoUrl + '?' + utmParam + '&utm_source=share_fb',
	                tw: _constants.shareLinks.TWITTER_SHARE + videoUrl + '?' + utmParam + '&utm_source=share_tw&&via=FoxSports&text=' + title,
	                em: _constants.shareLinks.MAIL + encodeURIComponent('Read more @FOXSports - ' + title) + '&body=Read more @FOXSports - ' + title + ' - ' + videoUrl + '?' + encodeURIComponent(utmParam + '&utm_source=share_em'),
	                whatsapp: 'whatsapp://send?text=' + videoUrl + '?' + encodeURIComponent(utmParam + '&utm_source=share_whatsapp'),
	                sms: this.isAndroid ? 'sms:?body=' + encodeURIComponent(smsShare) : 'sms:&body=' + smsShare,
	                cpyLink: url + '?' + utmParam + '&utm_source=share_url'
	            };
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _noImportant.css)(_icons.shareIcons.inlineContainer) },
	                _react2.default.createElement('input', { value: this.shareLinks.cpyLink, className: (0, _noImportant.css)(_VideoShareStyles.styles.hidden) + ' cpyLink' }),
	                _react2.default.createElement(
	                    'a',
	                    { href: this.shareLinks.fb, 'data-share-type': "fb",
	                        target: '_blank', className: (0, _noImportant.css)(_icons.shareIcons.icShareDefault) + " share-btn", onClick: this.trackShareLink },
	                    ' ',
	                    _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.shareIcons.icFacebook) + sharedClassName }),
	                    ' '
	                ),
	                this.isMobile && _react2.default.createElement(
	                    'a',
	                    { href: this.shareLinks.whatsapp, 'data-share-type': "whatsapp", className: (0, _noImportant.css)(shareStyles), onClick: this.trackShareLink },
	                    ' ',
	                    _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.shareIcons.icWhatsappShare) + sharedClassName }),
	                    ' '
	                ),
	                this.isMobile && _react2.default.createElement(
	                    'a',
	                    { href: this.shareLinks.sms, 'data-share-type': "sms", className: (0, _noImportant.css)(shareStyles), onClick: this.trackShareLink },
	                    ' ',
	                    _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.shareIcons.icSmsShare) + sharedClassName }),
	                    ' '
	                ),
	                !this.isMobile && _react2.default.createElement(
	                    'button',
	                    { 'data-share-type': "url", className: (0, _noImportant.css)(shareStyles, _icons.shareIcons.icShareBtn) + " social-bar-button share-url", onClick: this.handleCopyToClipboard, onMouseLeave: this.onMouseLeave },
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: (0, _noImportant.css)(_icons.shareIcons.icUrlShare) + sharedClassName },
	                        ' '
	                    ),
	                    ' '
	                ),
	                !this.isMobile && _react2.default.createElement(
	                    'a',
	                    { href: this.shareLinks.em, 'data-share-type': "email", className: (0, _noImportant.css)(shareStyles), onClick: this.trackShareLink },
	                    ' ',
	                    _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.shareIcons.icEmailShare) + sharedClassName }),
	                    ' '
	                )
	            );
	        }
	    }]);
	
	    return VideoShare;
	}(_react2.default.Component);
	
	exports.default = VideoShare;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = undefined;
	
	var _noImportant = __webpack_require__(15);
	
	var styles = exports.styles = _noImportant.StyleSheet.create({
	    hidden: {
	        position: 'fixed',
	        zIndex: '-1',
	        border: 'none',
	        opacity: 0
	    }
	});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ScriptLoader = __webpack_require__(59);
	
	var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);
	
	var _utils = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Analytics = function () {
	    function Analytics() {
	        _classCallCheck(this, Analytics);
	
	        if (null !== document.querySelector('[fs-prop="analytics"]')) {
	            this.init();
	        }
	    }
	
	    _createClass(Analytics, [{
	        key: 'init',
	        value: function init() {
	            this.isUtagLoaded = false;
	            this.metaObj = this.getPageMeta();
	            this.refreshRate = this.metaObj ? this.metaObj.refresh_rate : 0;
	            this.reSendMetadata();
	            this.metadataStorage = [];
	
	            //save the first article mata data
	            this.setMetadataStorage(0, this.metaObj);
	        }
	
	        /**
	         * @desc On gallery angular app, we need to update analytic meta data on every image slide onScroll.
	         *      this method is to pass the analytic meta data to /components/galleryPage/scripts/ads/adsService.js.
	         *      we call this method on pageload to set meta data for the first story. The method will be called again
	         *      on url change on 3things
	         * @param i this.metadataStorage index
	         * @param meta Meta object
	         */
	
	    }, {
	        key: 'setMetadataStorage',
	        value: function setMetadataStorage(i, meta) {
	
	            this.metadataStorage[i] = {
	                page_name: meta.page_name,
	                page_type: meta.page_type,
	                category: meta.category,
	                author: meta.author,
	                story_title: meta.story_title
	            };
	        }
	    }, {
	        key: 'getUtagLib',
	        value: function getUtagLib(url, callback) {
	
	            _ScriptLoader2.default.getScript(url, callback, true);
	        }
	    }, {
	        key: 'loadUtagLib',
	        value: function loadUtagLib(url) {
	            var _this = this;
	
	            if (!this.isUtagLoaded) {
	                this.getUtagLib(url, function () {
	                    _this.isUtagLoaded = true;
	                });
	            }
	        }
	
	        // on page load
	
	    }, {
	        key: 'sendPageView',
	        value: function sendPageView(data) {
	            //get page metadata if nothing is passed
	            var data = data || this.metaObj;
	
	            this.loadUtagLib(data.utaglib_path);
	            window.utag_data = data;
	        }
	    }, {
	        key: 'getPageMeta',
	        value: function getPageMeta() {
	            return (0, _utils.getPageMeta)();
	        }
	    }, {
	        key: 'reSendMetadata',
	        value: function reSendMetadata() {
	
	            if (this.refreshRate > 0) {
	                setInterval(function () {
	                    var data = window.utag_data;
	                    if (data !== null || data !== undefined) {
	                        this.utagView(window.utag_data);
	                    }
	                }.bind(this), this.refreshRate * 1000);
	            }
	        }
	
	        //utag api - call for any subsequent utag views
	
	    }, {
	        key: 'utagView',
	        value: function utagView(data) {
	
	            this.loadUtagLib(window.utag_data.utaglib_path);
	            /* current data format (dont remove this yet)
	            {
	             "account": "foxsports",
	             "page_name": "fscom:home:home",
	             "utags": "home|west|mlb",
	             "category": "home",
	             "page_type": "home",
	             "cms_id": "12121",
	             "page_topic": "classes:fsdigital/fscom/Home,classes:fsdigital/fscom/local/west/top-headlines,classes:fsdigital/fscom/local/west,internal:components/buzzer/mlb",
	             "filename": "http://www.foxsports.com/home",
	             "user_state": "",
	             "analyticsRefreshRate": "0"
	            }
	            */
	
	            try {
	                if (typeof utag !== 'undefined') {
	                    utag.view(data);
	                }
	            } catch (e) {
	                console.log(e);
	                throw new Error("ANALYTICS !! - something went wrong calling utag.view");
	            }
	        }
	
	        //event and link tracking
	
	    }, {
	        key: 'utagLink',
	        value: function utagLink(data) {
	            data.test = "fb-click";
	
	            try {
	                utag.link(data);
	            } catch (e) {
	                throw new Error("ANALYTICS !! - something went wrong calling utag.link");
	            }
	        }
	    }, {
	        key: 'sendEventView',
	        value: function sendEventView(data) {
	            this.utagLink(data);
	        }
	    }]);
	
	    return Analytics;
	}();
	
	exports.default = new Analytics();

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptLoader = function () {
		function ScriptLoader() {
			_classCallCheck(this, ScriptLoader);
	
			this.loadedAssets = [];
		}
	
		//get browser base url
	
	
		_createClass(ScriptLoader, [{
			key: 'getBaseurl',
			value: function getBaseurl() {
				var loc = location;
				return loc.origin || loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
			}
	
			/**
	   * @desc check url is injected to the DOM
	   * @param url
	   * @returns {undefined or bool}
	   */
	
		}, {
			key: 'getLoadedAssets',
			value: function getLoadedAssets(url) {
				return this.loadedAssets[url];
			}
	
			/**
	   * @desc push styles or scripts into this.loadedAssets array and set its value to be boolean value
	   *       to indicate the files are loaded.
	   * @param url
	   * @param v
	   */
	
		}, {
			key: 'setLoadedAssets',
			value: function setLoadedAssets(url, v) {
				this.loadedAssets[url] = v;
			}
	
			/**
	   * inject the styles in the head
	   * @param url
	   */
	
		}, {
			key: 'getStyles',
			value: function getStyles(url) {
	
				//check if the file is loaded
				var isFileLoaded = this.getLoadedAssets(url);
	
				//if it is yes, return to the caller
				if (isFileLoaded === true) {
					return;
				}
	
				var head = document.head,
				    link = document.createElement('link');
	
				link.type = 'text/css';
				link.rel = 'stylesheet';
				link.href = url;
	
				head.appendChild(link);
	
				/**
	    * call this.setLoadedAssets to set url in this.loadedAssets
	    * to be true, indicating the file is loaded.
	    */
				this.setLoadedAssets(url, true);
			}
	
			/**
	   * @desc inject scripts into DOM dynamically with sync or async and execute a callback after script is loaded
	   * @param string url
	   * @param function callback
	   * @param bool async - true or false
	   * @return undefined
	   */
	
		}, {
			key: 'getScript',
			value: function getScript(url, callback, async) {
	
				// Create a new script and setup the basics.
				var script = document.createElement("script");
				var firstScript = document.getElementsByTagName('script')[0];
	
				//if the third argument is passed, load the script asynchronously; otherwise load it synchronously
				if (async === undefined && async !== false) {
					script.async = true;
				} else {
					script.async = false;
				}
	
				script.src = url;
				// Handle the case where an optional callback was passed in.
				if ("function" === typeof callback) {
					script.onload = function () {
	
						callback();
						// Clear it out to avoid getting called more than once or any memory leaks.
						script.onload = script.onreadystatechange = undefined;
					};
	
					script.onreadystatechange = function () {
						if ("loaded" === script.readyState || "complete" === script.readyState) {
							script.onload();
						}
					};
				}
	
				//Attach the script tag to the page (before the first script) so the magic can happen.
				firstScript.parentNode.insertBefore(script, firstScript);
			}
		}]);
	
		return ScriptLoader;
	}();
	
	exports.default = new ScriptLoader();

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.playerStyles = undefined;
	
	var _playerCont, _videoCont, _playerSizes, _playlist;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var playerStyles = exports.playerStyles = _noImportant.StyleSheet.create({
	
	    playerCont: (_playerCont = {
	        display: 'block',
	        position: 'relative',
	        minHeight: 'inherit',
	        padding: '20px 20px 0',
	        backgroundColor: _vars.color.cobaltBlue
	
	    }, _defineProperty(_playerCont, _constants.media.MOBILE, {
	        display: 'inline-block',
	        padding: '0',
	        height: '100%',
	        maxHeight: 'inherit',
	        width: '100%'
	    }), _defineProperty(_playerCont, _constants.media.AT_LEAST_LAPTOP, {
	        minHeight: 500
	    }), _playerCont),
	
	    videoCont: (_videoCont = {
	        height: '100%',
	        marginRight: '370px'
	
	    }, _defineProperty(_videoCont, _constants.media.LAPTOP, {
	        marginRight: '330px'
	    }), _defineProperty(_videoCont, _constants.media.TABLET, {
	        marginRight: '310px'
	    }), _defineProperty(_videoCont, _constants.media.MOBILE, {
	        width: '100%',
	        float: 'none'
	    }), _defineProperty(_videoCont, _constants.media.SMALL, {
	        width: '100%',
	        float: 'none'
	    }), _videoCont),
	
	    playerSizes: (_playerSizes = {
	        width: '100%',
	        backgroundColor: _vars.color.black,
	        minHeight: 420
	    }, _defineProperty(_playerSizes, _constants.media.LAPTOP, {
	        minHeight: 287
	    }), _defineProperty(_playerSizes, _constants.media.TABLET, {
	        minHeight: 230
	    }), _defineProperty(_playerSizes, _constants.media.MOBILE, {
	        width: '100%',
	        minHeight: 230
	    }), _defineProperty(_playerSizes, _constants.media.SMALL, {
	        width: '100%',
	        minHeight: 211
	    }), _playerSizes),
	
	    playerMeta: _defineProperty({}, _constants.media.MOBILE, {
	        margin: '0px 10px',
	        transition: 'all .3s ease-out'
	    }),
	
	    playlist: (_playlist = {
	        width: '100%',
	        maxWidth: '370px',
	        height: '100%',
	        float: 'right',
	        overflowY: 'auto',
	        position: 'absolute',
	        top: '20px',
	        right: '10px',
	        '::-webkit-scrollbar': {
	            display: 'none'
	        }
	    }, _defineProperty(_playlist, _constants.media.LAPTOP, {
	        maxWidth: '330px'
	    }), _defineProperty(_playlist, _constants.media.TABLET, {
	        maxWidth: '310px'
	    }), _defineProperty(_playlist, _constants.media.MOBILE, {
	        maxWidth: '100%',
	        position: 'relative',
	        top: '0px',
	        right: '0px',
	        display: 'block',
	        float: 'none',
	        '-webkit-overflow-scrolling': 'touch'
	    }), _playlist),
	
	    title: _defineProperty({
	        fontFamily: 'Antenna',
	        fontSize: '18px',
	        fontWeight: _vars.fontWeight.bold,
	        lineHeight: 1.39,
	        textAlign: 'left',
	        color: _vars.color.white,
	        margin: '10px 0'
	
	    }, _constants.media.MOBILE, {
	        fontSize: 14
	    }),
	
	    props: {
	        marginBottom: '14px',
	        fontSize: '10px',
	        lineHeight: '1.43em',
	        color: _vars.color.gray,
	        display: 'flex',
	        alignItems: 'center',
	        fontWeight: _vars.fontWeight.semibold
	    },
	
	    moreLinkLabel: {
	        fontFamily: 'Antenna',
	        fontSize: '12px',
	        fontWeight: 500,
	        fontStyle: 'normal',
	        fontStretch: 'normal',
	        lineHeight: 'normal',
	        letterSpacing: '0.3px',
	        textAlign: 'left',
	        color: _vars.color.white
	    },
	
	    moreLink: {
	        display: 'inline-block',
	        width: '100%',
	        height: 'auto',
	        textAlign: 'center',
	        margin: 0,
	        textDecoration: 'none'
	    },
	
	    category: {
	        marginRight: '5px',
	        textTransform: 'uppercase',
	        ':before': {
	            content: '"|"',
	            margin: '0 5px'
	        }
	
	    },
	
	    unAvailableMsg: {
	        width: 292,
	        height: 45,
	        margin: '0 auto',
	        backgroundColor: _vars.color.cobaltBlue
	    },
	
	    unAvailableMsgLbl: {
	        display: 'block',
	        textAlign: 'center'
	    },
	
	    msgCont: {
	        width: '100%',
	        height: 45,
	        margin: '0 auto'
	    },
	
	    msgFontStyle: {
	        fontFamily: 'Antenna',
	        fontSize: 12,
	        fontWeight: 500,
	        fontStyle: 'normal',
	        fontStretch: 'normal',
	        lineHeight: '45px',
	        verticalAlign: 'middle',
	        letterSpacing: '0.1px',
	        textAlign: 'center',
	        display: 'block',
	        color: _vars.color.white
	    }
	
	});

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(15);
	
	var _FbShare = __webpack_require__(85);
	
	var _FbShare2 = _interopRequireDefault(_FbShare);
	
	var _icons = __webpack_require__(51);
	
	var _videoItemStyles = __webpack_require__(86);
	
	var _VideoPlayerService = __webpack_require__(14);
	
	var _FsPlayer = __webpack_require__(13);
	
	var _FsPlayer2 = _interopRequireDefault(_FsPlayer);
	
	var _constants = __webpack_require__(53);
	
	var _utils = __webpack_require__(8);
	
	var _VideoModal = __webpack_require__(87);
	
	var _VideoModal2 = _interopRequireDefault(_VideoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SHOW_LOGO_SHOWN_MIN_WIDTH = 360;
	var FB_SHARE_SHOWN_MIN_WIDTH = 375;
	var INLINE_VIDEO_MIN_WIDTH = 261;
	var LARGE_FONT_SHOWN_MIN_WIDTH = 347;
	
	var containerSize = {
		LARGE: 560,
		MEDIUM: 360
	};
	
	var Style = function Style() {
		_classCallCheck(this, Style);
	
		this[_constants.media.LAPTOP] = {};
		this[_constants.media.TABLET] = {};
		this[_constants.media.MOBILE] = {};
	};
	
	var VideoItem = function (_React$Component) {
		_inherits(VideoItem, _React$Component);
	
		function VideoItem(props) {
			_classCallCheck(this, VideoItem);
	
			var _this = _possibleConstructorReturn(this, (VideoItem.__proto__ || Object.getPrototypeOf(VideoItem)).call(this, props));
	
			_this.state = { videoHover: false };
	
			_this.loader = null;
			_this.isPlaying = false;
	
			_this.playVideo = _this.playVideo.bind(_this);
			_this.toggleVideoHover = _this.toggleVideoHover.bind(_this);
			_this.isShow = _this.props.isShow;
	
			_this.isModalEnabled = document.body.classList.contains('video-modal');
			_this.modalCont = document.getElementById('video-player-modal');
			_this.onResize = _this.updateElementsVisibility.bind(_this);
			_this.onResize = _this.updateElementsVisibility.bind(_this);
			return _this;
		}
	
		_createClass(VideoItem, [{
			key: 'toggleVideoHover',
			value: function toggleVideoHover() {
				this.setState({ videoHover: !this.state.videoHover });
			}
		}, {
			key: 'isContainerWidthOk',
			value: function isContainerWidthOk(width) {
				if (!this.container) {
					return false;
				}
	
				return this.container.offsetWidth >= width;
			}
		}, {
			key: 'getContainerSize',
			value: function getContainerSize() {
				if (!this.container) {
					return '';
				}
	
				if (this.container.offsetWidth < containerSize.MEDIUM) {
					return 'small';
				}
	
				if (this.container.offsetWidth < containerSize.LARGE) {
					return 'medium';
				}
	
				return 'large';
			}
		}, {
			key: 'updateElementsVisibility',
			value: function updateElementsVisibility() {
				return this._isMounted && this.forceUpdate();
			}
		}, {
			key: 'updateMediaStyles',
			value: function updateMediaStyles() {
				var mediaSettings = this.props.mediaSettings;
	
				var item = new Style();
				var firstItem = new Style();
				var firstItemMeta = new Style();
				var itemMeta = new Style();
	
				Object.assign(item, mediaSettings.desktop.item);
				Object.assign(item[_constants.media.LAPTOP], mediaSettings.laptop.item);
				Object.assign(item[_constants.media.TABLET], mediaSettings.tablet.item);
				Object.assign(item[_constants.media.MOBILE], mediaSettings.mobile.item);
	
				if (mediaSettings.desktop.firstItem) {
					Object.assign(firstItem, mediaSettings.desktop.firstItem);
	
					this.addFirstItemStyles = true;
				}
	
				if (mediaSettings.mobile.firstItem) {
					Object.assign(firstItem[_constants.media.MOBILE], mediaSettings.mobile.firstItem);
	
					this.addFirstItemStyles = true;
				}
	
				if (mediaSettings.mobile.firstItemMeta) {
					Object.assign(firstItemMeta[_constants.media.MOBILE], mediaSettings.mobile.firstItemMeta);
	
					this.addFirstItemMetaStyles = true;
				}
	
				if (mediaSettings.mobile.itemMeta) {
					Object.assign(itemMeta[_constants.media.MOBILE], mediaSettings.mobile.itemMeta);
	
					this.addItemMetaStyles = true;
				}
	
				this.itemMediaStyles = _noImportant.StyleSheet.create({
					item: item,
					firstItem: firstItem,
					firstItemMeta: firstItemMeta,
					itemMeta: itemMeta
				});
			}
		}, {
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.updateMediaStyles();
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this._isMounted = true;
				setTimeout(this.onResize, 0);
				this.player.setAttribute('enable-pinning', 'true');
	
				if (window) {
					window.addEventListener("resize", this.onResize);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._isMounted = false;
				if (window) {
					window.removeEventListener("resize", this.onResize);
				}
			}
		}, {
			key: 'playVideo',
			value: function playVideo(e) {
				var _this2 = this;
	
				var isCatLink = function (target) {
	
					if (target.tagName === "IMG") {
						target = target.parentElement || target.parentNode;
					}
					if (target.tagName === "A" && target.className.indexOf('categoryLogoContainer') > -1) {
						return true;
					}
	
					return false;
				}(e.target);
	
				if (e.target.className.indexOf(_FbShare.FB_ICON_CLASS_NAME) >= 0 || !this.isContainerWidthOk(INLINE_VIDEO_MIN_WIDTH) && !this.isPlaying || isCatLink || this.props.post.open_in_new_window === "1" || e.target.className.indexOf("share-btn") >= 0) {
					return;
				}
	
				//skip playing the video inline if scroll to home flag has been added
				var isScrollToHome = document.querySelector('.scrollToHome');
				if (isScrollToHome) return;
	
				e.stopPropagation();
				e.preventDefault();
	
				if (this.isModalEnabled) {
					this.modalCont.style = 'display:block';
					//render the modal
					ReactDOM.render(_react2.default.createElement(_VideoModal2.default, { videoConfig: this.player.getAttribute('data-player-config'), category: this.props.post.category_meta.category_name,
						title: this.props.post.title, pubDate: this.props.post.pub_date, videoUrl: this.props.post.url }), this.modalCont);
				} else {
	
					if (this.isPlaying) {
						return;
					}
	
					this.isPlaying = true;
	
					(0, _VideoPlayerService.loadVideoPlayer)(this.player, this.link.offsetWidth, this.link.offsetHeight, function () {
						_this2.link.style.display = 'none';
					});
				}
			}
		}, {
			key: 'getClassName',
			value: function getClassName(className) {
				return className + '_' + (this.props.classPostfix || '');
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var post = this.props.post || {};
				post.title = (0, _utils.decodeText)(post.title);
				if (typeof this.props.utmObj !== 'undefined') {
					post.video_config.utm = this.props.utmObj;
				}
	
				var target = post.open_in_new_window ? '_blank' : "_self";
	
				var categoryUrl = post.video_config.siteSection;
				var categoryLinkTarget = categoryUrl.indexOf("foxsports.com") > -1 ? "_self" : "_blank";
	
				if ("_self" === categoryLinkTarget) categoryUrl = categoryUrl.replace("foxsports.com", "");
	
				var containerStyles = [_videoItemStyles.styles.item, this.itemMediaStyles.item];
				var metaStyles = [_videoItemStyles.styles.meta];
				var playBtnStyles = [_icons.playIcon.icPlayTiny, _videoItemStyles.styles.zIndexOne];
				var imagesTag = (0, _utils.parseImagesTag)(post.res_imgs_tag);
	
				if (this.props.innerIndex === 0 && !this.isShow) {
					if (this.addFirstItemStyles) {
						containerStyles.push(this.itemMediaStyles.firstItem);
					}
	
					if (this.addFirstItemMetaStyles) {
						metaStyles.push(this.itemMediaStyles.firstItemMeta);
					}
				}
	
				if (this.isShow) {
					containerStyles.push(_videoItemStyles.styles.showItem);
				}
	
				if (this.addItemMetaStyles) {
					metaStyles.push(this.itemMediaStyles.itemMeta);
				}
	
				if (this.state.videoHover) {
					playBtnStyles.push(_icons.playIcon.icPlayHover);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(containerStyles) + ' ' + this.getClassName('container') + '-' + this.props.outerIndex,
						'data-size': this.getContainerSize(),
						ref: function ref(div) {
							return _this3.container = div;
						},
						onClick: this.playVideo },
					_react2.default.createElement(_FsPlayer2.default, { playerRef: function playerRef(player) {
							return _this3.player = player;
						}, playerConfig: post.video_config }),
					_react2.default.createElement(
						'a',
						{ href: post.url,
							title: post.title,
							ref: function ref(a) {
								return _this3.link = a;
							},
							className: (0, _noImportant.css)(_videoItemStyles.styles.imageLink) + ' ' + this.getClassName('image-link'),
							onMouseEnter: this.toggleVideoHover,
							onMouseLeave: this.toggleVideoHover, target: target },
						_react2.default.createElement(
							'div',
							{ className: (0, _noImportant.css)(_videoItemStyles.styles.overlay) + ' ' + this.getClassName('overlay') },
							_react2.default.createElement('img', { alt: post.title,
								'data-src': imagesTag.src,
								'data-srcset': imagesTag.srcSet,
								'data-sizes': imagesTag.sizes,
								className: (0, _noImportant.css)(_videoItemStyles.styles.image) + ' ' + this.getClassName('image') + ' lazyload' }),
							imagesTag.noscript && _react2.default.createElement(
								'noscript',
								null,
								imagesTag.noscript
							),
							_react2.default.createElement(
								'span',
								{ className: (0, _noImportant.css)(_videoItemStyles.styles.playIcon) + ' ' + this.getClassName('play-icon') },
								_react2.default.createElement('span', { className: (0, _noImportant.css)(playBtnStyles) + ' ' + this.getClassName('play-dtn') }),
								post.video_duration && _react2.default.createElement(
									'span',
									{ className: (0, _noImportant.css)(_videoItemStyles.styles.durationContainer) },
									_react2.default.createElement(
										'span',
										{ className: (0, _noImportant.css)(_videoItemStyles.styles.duration) },
										(0, _utils.parseSeconds)(post.video_duration)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(metaStyles) + ' ' + this.getClassName('meta'), ref: function ref(div) {
								return _this3.meta = div;
							} },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'h2',
								{ className: (0, _noImportant.css)(_videoItemStyles.styles.titleHeader) + ' ' + this.getClassName('title-header') },
								_react2.default.createElement(
									'a',
									{ ref: function ref(a) {
											return _this3.titleLink = a;
										},
										href: post.url,
										title: post.title,
										className: this.isShow ? (0, _noImportant.css)(_videoItemStyles.styles.titleShowLink, this.isContainerWidthOk(LARGE_FONT_SHOWN_MIN_WIDTH) && _videoItemStyles.styles.titleLinkLarge) : (0, _noImportant.css)(_videoItemStyles.styles.titleLink, this.isContainerWidthOk(LARGE_FONT_SHOWN_MIN_WIDTH) && _videoItemStyles.styles.titleLinkLarge) + ' ' + this.getClassName('title-link'),
										target: target },
									post.title
								)
							),
							_react2.default.createElement(
								'div',
								{ className: this.isShow ? (0, _noImportant.css)(_videoItemStyles.styles.props, _videoItemStyles.styles.propsShow) : (0, _noImportant.css)(_videoItemStyles.styles.props) + ' ' + this.getClassName('props') },
								_react2.default.createElement(
									'span',
									null,
									_react2.default.createElement(
										'span',
										{ className: (0, _noImportant.css)(_videoItemStyles.styles.time) + ' ' + this.getClassName('time') },
										_react2.default.createElement(
											'time',
											{ dateTime: post.pub_date || '' },
											post.pub_date || ''
										)
									),
									!this.isShow && _react2.default.createElement(
										'span',
										{ className: (0, _noImportant.css)(_videoItemStyles.styles.category) + ' ' + this.getClassName('category') },
										post.category_meta.category_name || post.author
									)
								),
								this.isContainerWidthOk(FB_SHARE_SHOWN_MIN_WIDTH) && _react2.default.createElement(_FbShare2.default, { url: post.url })
							)
						),
						this.isContainerWidthOk(SHOW_LOGO_SHOWN_MIN_WIDTH) && post.category_meta.logo_url && !this.isShow && _react2.default.createElement(
							'a',
							{ className: (0, _noImportant.css)(_videoItemStyles.styles.categoryLogoContainer) + ' ' + this.getClassName('logo'), href: categoryUrl, target: categoryLinkTarget },
							_react2.default.createElement('img', { alt: post.title, className: (0, _noImportant.css)(_videoItemStyles.styles.categoryLogo) + ' ' + this.getClassName('logo-img'), src: post.category_meta.logo_url })
						)
					)
				);
			}
		}]);
	
		return VideoItem;
	}(_react2.default.Component);
	
	exports.default = VideoItem;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FB_ICON_CLASS_NAME = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FB_ICON_CLASS_NAME = exports.FB_ICON_CLASS_NAME = 'fbIcon';
	
	var FbShare = function (_React$Component) {
		_inherits(FbShare, _React$Component);
	
		function FbShare(props) {
			_classCallCheck(this, FbShare);
	
			return _possibleConstructorReturn(this, (FbShare.__proto__ || Object.getPrototypeOf(FbShare)).call(this, props));
		}
	
		_createClass(FbShare, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'a',
					{ href: (0, _utils.getFbShareUrl)(this.props.url),
						'data-url-to-track': this.props.url,
						target: '_blank',
						onClick: _utils.fbShareParselyTrackLink
					},
					_react2.default.createElement('span', { className: (0, _noImportant.css)(styles.fbIcon) })
				);
			}
		}]);
	
		return FbShare;
	}(_react2.default.Component);
	
	exports.default = FbShare;
	
	
	var styles = _noImportant.StyleSheet.create(_defineProperty({}, FB_ICON_CLASS_NAME, {
		display: 'inline-block',
		width: '59px',
		height: '20px',
		background: 'url(' + _vars.iconUrl.facebookShare + ')',
		backgroundSize: '100%'
	}));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.styles = undefined;
	
	var _titleShowLink, _showItem;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = exports.styles = _noImportant.StyleSheet.create({
		item: {
			marginBottom: '30px'
		},
		overlay: {
			position: 'relative'
		},
		image: {
			width: '100%',
			display: 'block',
			height: '100%',
			borderRadius: '2px'
		},
		imageLink: {
			display: 'block'
		},
		playIcon: {
			position: 'absolute',
			bottom: '0',
			minWidth: '35px',
			height: '45px',
			display: 'inline-flex',
			alignItems: 'center',
			paddingLeft: '10px'
		},
		durationContainer: {
			position: 'absolute',
			left: '34px',
			top: '11px'
		},
		duration: {
			backgroundColor: 'rgba(0, 0, 0, 0.75)',
			height: '18px',
			position: 'relative',
			fontSize: '10px',
			fontWeight: _vars.fontWeight.bold,
			color: _vars.color.white,
			paddingLeft: '6px',
			paddingRight: '5px',
			borderTopRightRadius: '2px',
			borderBottomRightRadius: '2px',
	
			':after': {
				content: '""',
				position: 'absolute',
				width: '18px',
				top: '0',
				bottom: '0',
				right: '100%',
				backgroundColor: 'transparent',
				borderTopRightRadius: '25% 11px',
				borderBottomRightRadius: '25% 11px',
				boxShadow: '14px 0px 0px 0px rgba(0, 0, 0, 0.75)',
				clip: 'rect(0px, 18px, 18px, 0px)'
			}
		},
		zIndexOne: {
			zIndex: '1'
		},
		meta: {
			display: 'flex',
			justifyContent: 'space-between',
			marginTop: '5px'
		},
		titleHeader: {
			margin: '0'
		},
		titleLink: {
			fontSize: '12px',
			fontWeight: _vars.fontWeight.semibold,
			lineHeight: '1.5em',
			color: _vars.color.darkGray,
			textDecoration: 'none',
			display: 'block',
	
			':hover': {
				color: _vars.color.darkBlue
			}
	
		},
	
		titleShowLink: (_titleShowLink = {
			fontSize: '14px',
			fontWeight: _vars.fontWeight.semibold,
			lineHeight: '1.5em',
			color: _vars.color.white,
			textDecoration: 'none',
			display: 'block'
	
		}, _defineProperty(_titleShowLink, _constants.media.TABLET, {
			fontSize: '12px'
		}), _defineProperty(_titleShowLink, _constants.media.MOBILE, {
			fontSize: '11px',
			color: '#3c3d48',
			fontWeight: '500',
			padding: '0 5px'
		}), _titleShowLink),
	
		titleLinkLarge: {
			fontSize: '14px',
			lineHeight: '1.43em'
		},
		props: {
			marginTop: '6px',
			fontSize: '10px',
			lineHeight: '1.43em',
			color: _vars.color.gray,
			display: 'flex',
			alignItems: 'center',
			fontWeight: '500'
		},
		propsShow: _defineProperty({}, _constants.media.MOBILE, {
			display: 'none'
		}),
		category: {
			marginRight: '5px',
			':before': {
				content: '"|"',
				margin: '0 5px'
			}
		},
		categoryLogoContainer: {
			marginLeft: '10px'
		},
		categoryLogo: {
			width: '50px'
		},
	
		showItem: (_showItem = {}, _defineProperty(_showItem, _constants.media.MOBILE, {
			minWidth: '165px',
			minHeight: '150px',
			backgroundColor: 'white',
			color: '#3c3d48',
			padding: '5px',
			margin: '5px',
			borderRadius: '2px',
			display: 'inline-block',
			boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
		}), _defineProperty(_showItem, _constants.media.SMALL, {
			minWidth: '140px',
			minHeight: '145px'
		}), _showItem)
	});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FsPlayer = __webpack_require__(13);
	
	var _FsPlayer2 = _interopRequireDefault(_FsPlayer);
	
	var _VideoPlaylist = __webpack_require__(49);
	
	var _VideoPlaylist2 = _interopRequireDefault(_VideoPlaylist);
	
	var _VideoPlayerService = __webpack_require__(14);
	
	var _icons = __webpack_require__(51);
	
	var _VideoModalStyles = __webpack_require__(88);
	
	var _noImportant = __webpack_require__(15);
	
	var _FsPlaylistService = __webpack_require__(3);
	
	var _FsPlaylistService2 = _interopRequireDefault(_FsPlaylistService);
	
	var _VideoShare = __webpack_require__(56);
	
	var _VideoShare2 = _interopRequireDefault(_VideoShare);
	
	var _Viewports = __webpack_require__(12);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	var _screenLock = __webpack_require__(89);
	
	var _screenLock2 = _interopRequireDefault(_screenLock);
	
	var _VideoPlayerStyles = __webpack_require__(60);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoModal = function (_React$Component) {
	    _inherits(VideoModal, _React$Component);
	
	    function VideoModal(props) {
	        _classCallCheck(this, VideoModal);
	
	        var _this = _possibleConstructorReturn(this, (VideoModal.__proto__ || Object.getPrototypeOf(VideoModal)).call(this, props));
	
	        _this.state = {
	            showModal: true,
	            topVideos: [],
	            width: window.innerWidth,
	            releaseUrl: '',
	            currentPost: null,
	            displayDetails: true
	        };
	
	        _this.viewport = new _Viewports2.default({
	            'mobile': 767,
	            'desktop': 1024
	        });
	
	        _this.isPlaying = false;
	        _this.modalCont = document.getElementById('video-player-modal');
	        _this.openModal = _this.openModal.bind(_this);
	        _this.closeModal = _this.closeModal.bind(_this);
	        _this.handleModalClose = _this.handleModalClose.bind(_this);
	        _this.category = _this.props.category;
	        _this.title = _this.props.title;
	        _this.pubDate = _this.props.pubDate;
	        _this.videoConfig = _this.props.videoConfig;
	        _this.videoConfigObject = JSON.parse(_this.videoConfig);
	        _this.limit = 7;
	        _this.post = {
	            title: _this.title,
	            pubDate: _this.pubDate,
	            videoConfig: _this.videoConfig,
	            videoUrl: _this.props.videoUrl
	        };
	        _this.playerMetaHeight = 0;
	
	        //sets up callback which returns post meta of the clicked video 
	        _this.updateCurrentPost = _this.updateCurrentPost.bind(_this);
	        _this.updateDetails = _this.updateDetails.bind(_this);
	        document.body.classList.add('video-modal-is-active');
	
	        _this.screenLock = new _screenLock2.default();
	
	        _this.screenLock.lockScreen();
	        return _this;
	    }
	
	    _createClass(VideoModal, [{
	        key: 'updateCurrentPost',
	        value: function updateCurrentPost(post) {
	            this.setState({ releaseUrl: post.releaseUrl, currentPost: post });
	            var cPlayer = window.currentPlayer;
	            if (cPlayer) {
	                if (this.modalOverlay.scrollTop > 0) this.modalOverlay.scrollTop = 0;
	                cPlayer.setReleaseCall(post.releaseUrl);
	            }
	        }
	    }, {
	        key: 'updateDetails',
	        value: function updateDetails(e) {
	            var el = this.playerMeta;
	            if (this.viewport.isMobile || this.viewport.winW <= 767) {
	                this.setState(function () {
	                    return {
	                        displayDetails: e.target.scrollTop <= 0
	                    };
	                });
	            }
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.setState({ showModal: true });
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal() {
	            this.modalCont.style = 'display: none';
	            document.body.classList.remove('video-modal-is-active');
	            this.screenLock.unlockScreen();
	            if (window.currentPlayer) window.currentPlayer.setReleaseCall('');
	
	            setTimeout(function () {
	                var modalCont = document.getElementById('video-player-modal');
	                if (modalCont) _reactDom2.default.unmountComponentAtNode(modalCont);
	            }, 0);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var postId = (0, _utils.getPostId)();
	            //fetch new top videos
	            new _FsPlaylistService2.default().getMpxPlaylist(this.videoConfigObject.endcard_feed, this.limit, postId).then(function (topVideos) {
	                _this2.setState(function () {
	                    return {
	                        topVideos: topVideos
	                    };
	                });
	            });
	
	            if (this.playerMeta.clientHeight > 0) {
	                this.playerMetaHeight = this.playerMeta.clientHeight;
	            }
	            var modal = document.querySelector('#video-player-modal');
	            var player = modal.querySelector('.fs-video-player');
	            var playerCont = modal.querySelector('.vm-player-cont');
	
	            setTimeout(function () {
	                (0, _VideoPlayerService.loadVideoPlayer)(player, playerCont.clientWidth, playerCont.clientHeight, null);
	            }, 0);
	        }
	    }, {
	        key: 'handleModalClose',
	        value: function handleModalClose(e) {
	            if (e.target.className.indexOf('overlayBg_') > -1) this.closeModal();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var topVideos = this.state.topVideos;
	            var post = this.state.currentPost || this.post;
	            var playerMetaStyles = [_VideoPlayerStyles.playerStyles.playerMeta];
	            if (!this.state.displayDetails) {
	                playerMetaStyles.push(_VideoModalStyles.styles.hideMeta);
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('div', { className: (0, _noImportant.css)(_VideoModalStyles.styles.overlayBg), onClick: this.handleModalClose }),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(el) {
	                            return _this3.modalOverlay = el;
	                        }, className: (0, _noImportant.css)(_VideoModalStyles.styles.overlay), onClick: this.handleModalClose },
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _noImportant.css)(_VideoModalStyles.styles.modal) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _noImportant.css)(_VideoModalStyles.styles.vmContainer) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _noImportant.css)(_VideoModalStyles.styles.vmHeader) },
	                                _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.icons.icFs) })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { className: (0, _noImportant.css)(_VideoModalStyles.styles.closeButton), onClick: this.closeModal },
	                                    _react2.default.createElement('span', { className: (0, _noImportant.css)(_icons.icons.icCloseIconWhite) })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.videoCont) + ' vm-player-cont' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.playerSizes) },
	                                        _react2.default.createElement(_FsPlayer2.default, { playerRef: 'player ref', playerConfig: post.videoConfig })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { ref: function ref(elem) {
	                                                return _this3.playerMeta = elem;
	                                            }, className: (0, _noImportant.css)(playerMetaStyles) },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { ref: function ref(el) {
	                                                    return _this3.metaCont = el;
	                                                } },
	                                            _react2.default.createElement(
	                                                'h2',
	                                                { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.title) },
	                                                ' ',
	                                                post.title,
	                                                ' '
	                                            ),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.props) },
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.time) },
	                                                    post.pubDate
	                                                ),
	                                                _react2.default.createElement(
	                                                    'span',
	                                                    { className: (0, _noImportant.css)(_VideoPlayerStyles.playerStyles.category) },
	                                                    this.category
	                                                )
	                                            ),
	                                            _react2.default.createElement(_VideoShare2.default, { title: post.title, videoUrl: post.videoUrl })
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _noImportant.css)(_VideoModalStyles.styles.vmMoreVideos) },
	                                topVideos.length > 0 && _react2.default.createElement(_VideoPlaylist2.default, { title: this.category, videos: topVideos, enableShowMore: false,
	                                    onClick: this.updateCurrentPost, showDetails: this.updateDetails, hideTitle: false })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoModal;
	}(_react2.default.Component);
	
	exports.default = VideoModal;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.styles = undefined;
	
	var _modal, _overlay, _vmMoreVideos, _vmMoreCont, _StyleSheet$create;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = exports.styles = _noImportant.StyleSheet.create((_StyleSheet$create = {
	    modal: (_modal = {
	        position: 'relative',
	        top: '0',
	        left: '0px',
	        right: '0px',
	        bottom: '0px',
	        maxWidth: '1240px',
	        margin: 'auto',
	        outline: 'none',
	        '-webkit-transform': 'translateZ(0)'
	
	    }, _defineProperty(_modal, _constants.media.LAPTOP, {
	        maxWidth: 1010
	    }), _defineProperty(_modal, _constants.media.TABLET, {
	        maxWidth: 750
	    }), _defineProperty(_modal, _constants.media.MOBILE, {
	        maxWidth: 767,
	        height: 'auto'
	    }), _modal),
	
	    overlay: (_overlay = {
	        position: 'fixed',
	        top: '111px',
	        left: '0px',
	        right: '0px',
	        bottom: '0px',
	        backgroundColor: _vars.color.cobaltBlue,
	        boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.3)',
	        zIndex: 100001,
	        height: 'auto',
	        width: '100%'
	
	    }, _defineProperty(_overlay, _constants.media.AT_LEAST_TABLET, {
	        display: 'table'
	    }), _defineProperty(_overlay, _constants.media.MOBILE, {
	        overflowY: 'scroll',
	        '-webkit-overflow-scrolling': 'touch',
	        height: '100%',
	        top: '0px',
	        zIndex: 100006,
	        '::-webkit-scrollbar': {
	            display: 'none'
	        }
	    }), _overlay),
	
	    vmContainer: _defineProperty({
	        width: '100%',
	        display: 'inline-flex',
	        height: '100%',
	        paddingTop: '20px'
	
	    }, _constants.media.MOBILE, {
	        display: 'block',
	        padding: '0'
	    }),
	
	    overlayBg: {
	        position: 'fixed',
	        left: '0',
	        top: '0',
	        width: '100%',
	        height: '100%',
	        zIndex: 999,
	        opacity: '0.7',
	        backgroundColor: '#1e242d'
	    },
	
	    vmHeader: _defineProperty({
	        display: 'none'
	
	    }, _constants.media.MOBILE, {
	        display: 'flex',
	        alignItems: 'center',
	        height: '45px',
	        padding: '0 15px'
	    }),
	
	    hideMeta: {
	        display: 'none'
	    },
	
	    closeButton: _defineProperty({
	        position: 'absolute',
	        width: '20px',
	        height: '20px',
	        right: 0
	
	    }, _constants.media.MOBILE, {
	        right: '15px',
	        top: '12px'
	    })
	
	}, _defineProperty(_StyleSheet$create, 'vmContainer', _defineProperty({
	    width: '100%',
	    display: 'block',
	    height: '100%',
	    paddingTop: '20px',
	    backgroundColor: _vars.color.cobaltBlue
	
	}, _constants.media.MOBILE, {
	    display: 'block',
	    padding: '0'
	})), _defineProperty(_StyleSheet$create, 'vmMoreVideos', (_vmMoreVideos = {
	    width: '100%',
	    maxWidth: '340px',
	    height: '100%',
	    float: 'right',
	    overflowY: 'auto',
	    position: 'absolute',
	    top: '20px',
	    right: '10px',
	    '::-webkit-scrollbar': {
	        display: 'none'
	    }
	}, _defineProperty(_vmMoreVideos, _constants.media.TABLET, {
	    maxWidth: '285px'
	}), _defineProperty(_vmMoreVideos, _constants.media.MOBILE, {
	    maxWidth: '100%',
	    position: 'relative',
	    top: '0px',
	    right: '0px',
	    display: 'block',
	    float: 'none',
	    '-webkit-overflow-scrolling': 'touch'
	}), _vmMoreVideos)), _defineProperty(_StyleSheet$create, 'vmMoreCont', (_vmMoreCont = {
	    overflowY: 'scroll',
	    '::-webkit-scrollbar': {
	        display: 'none'
	    }
	
	}, _defineProperty(_vmMoreCont, _constants.media.DESKTOP, {
	    height: 510
	}), _defineProperty(_vmMoreCont, _constants.media.LAPTOP, {
	    height: 440
	}), _defineProperty(_vmMoreCont, _constants.media.TABLET, {
	    height: 340
	}), _defineProperty(_vmMoreCont, _constants.media.MOBILE, {
	    maxHeight: 410
	}), _defineProperty(_vmMoreCont, _constants.media.SMALL, {
	    maxHeight: 275
	}), _vmMoreCont)), _StyleSheet$create));

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Viewports = __webpack_require__(12);
	
	var _Viewports2 = _interopRequireDefault(_Viewports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var screenLock = function () {
	    function screenLock() {
	        _classCallCheck(this, screenLock);
	
	        this.body = document.getElementsByTagName('body')[0];
	        this.header = document.getElementById('header-wrapper');
	        this.secondNav = document.querySelector('.section-nav');
	        this.lastYOffset = 0;
	
	        this.viewport = new _Viewports2.default({
	            'mobile': 767
	        });
	    }
	
	    _createClass(screenLock, [{
	        key: 'lockScreen',
	        value: function lockScreen() {
	            this.lastYOffset = window.pageYOffset;
	            if (!this.body.classList.contains('screen-lock')) {
	                this.body.style.top = this.lastYOffset * -1 + 'px';
	                this.body.classList.add('screen-lock');
	            }
	            this.header.classList.add('visible');
	            if (this.secondNav) this.secondNav.classList.add('fixed');
	        }
	    }, {
	        key: 'unlockScreen',
	        value: function unlockScreen() {
	            var yPos = this.body.style.top.replace(/[^-\d\.]/g, '') * -1;
	            this.body.style.top = null;
	            this.header.classList.remove('visible');
	            if (this.secondNav) this.secondNav.classList.remove('fixed');
	            this.body.classList.remove('screen-lock');
	            window.scrollTo(0, yPos);
	        }
	    }]);
	
	    return screenLock;
	}();
	
	exports.default = screenLock;

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(4);
	
	var _FetchService = __webpack_require__(5);
	
	var _TrackingUtils = __webpack_require__(10);
	
	var _TrackingUtils2 = _interopRequireDefault(_TrackingUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Collections = function Collections(success, data) {
		_classCallCheck(this, Collections);
	
		this.success = success || false;
		this.data = data || [];
	};
	
	var VideoCollectionsService = function () {
		function VideoCollectionsService() {
			_classCallCheck(this, VideoCollectionsService);
	
			this.getCollectionsProm = null;
			this.count = 0;
		}
	
		_createClass(VideoCollectionsService, [{
			key: 'getCollections',
			value: function getCollections(postId) {
				if (this.getCollectionsProm) {
					return this.getCollectionsProm;
				}
	
				this.getCollectionsProm = (0, _FetchService.get)(_constants.settings.COLLECTIONS_URL + postId, function (json) {
					if (!json.success) return [];
					var data = json.data;
					return Array.isArray(data) ? data : [data];
				}, function () {
					return [];
				});
	
				return this.getCollectionsProm;
			}
		}, {
			key: 'setCollectionUTM',
			value: function setCollectionUTM(collection, idx) {
				// if index isn't set, use internal counter
				if (typeof idx === 'undefined') this.count++;
	
				var result = {
					source: 'homepage'
				};
				result.term = typeof idx !== 'undefined' ? 'collection_' + idx : 'collection_' + this.count;
				/* if tags aren't present, convert the collection's title as a tag/slug for "utm_content" use. */
				/* 'undefined' if title is not set */
				result.content = collection.tags && collection.tags.length > 0 ? collection.tags[0] : typeof collection.collectionTitle !== 'undefined' ? _TrackingUtils2.default.formatStringAsSlug(collection.collectionTitle) : undefined;
	
				return result;
			}
		}]);
	
		return VideoCollectionsService;
	}();
	
	exports.default = new VideoCollectionsService();

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(15);
	
	var _ThreeItems = __webpack_require__(97);
	
	var _ThreeItems2 = _interopRequireDefault(_ThreeItems);
	
	var _FourItems = __webpack_require__(99);
	
	var _FourItems2 = _interopRequireDefault(_FourItems);
	
	var _FiveItems = __webpack_require__(100);
	
	var _FiveItems2 = _interopRequireDefault(_FiveItems);
	
	var _SixItems = __webpack_require__(101);
	
	var _SixItems2 = _interopRequireDefault(_SixItems);
	
	var _SevenItems = __webpack_require__(102);
	
	var _SevenItems2 = _interopRequireDefault(_SevenItems);
	
	var _EightItems = __webpack_require__(103);
	
	var _EightItems2 = _interopRequireDefault(_EightItems);
	
	var _videoCollectionStyles = __webpack_require__(104);
	
	var _VideoCollectionsService = __webpack_require__(95);
	
	var _VideoCollectionsService2 = _interopRequireDefault(_VideoCollectionsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var containers = [null, null, null, _ThreeItems2.default, _FourItems2.default, _FiveItems2.default, _SixItems2.default, _SevenItems2.default, _EightItems2.default];
	
	var VideoCollection = function (_React$Component) {
		_inherits(VideoCollection, _React$Component);
	
		function VideoCollection(props) {
			_classCallCheck(this, VideoCollection);
	
			var _this = _possibleConstructorReturn(this, (VideoCollection.__proto__ || Object.getPrototypeOf(VideoCollection)).call(this, props));
	
			_this.state = {
				collection: props.collection
			};
			return _this;
		}
	
		_createClass(VideoCollection, [{
			key: 'render',
			value: function render() {
				var collection = this.state.collection;
				var ContainerTag = containers[collection.posts.length] || _ThreeItems2.default;
				var utmObj = _VideoCollectionsService2.default.setCollectionUTM(collection, this.props.index);
	
				return _react2.default.createElement(
					'div',
					{ id: this.props.id },
					_react2.default.createElement('input', { type: 'hidden', value: collection.posts.length, className: 'collection-size_vc' }),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(_videoCollectionStyles.styles.header) + ' header_vc' },
						_react2.default.createElement(
							'h3',
							{ className: (0, _noImportant.css)(_videoCollectionStyles.styles.title) + ' title_vc' },
							collection.collectionTitle
						),
						_react2.default.createElement(
							'a',
							{ className: (0, _noImportant.css)(_videoCollectionStyles.styles.moreLink, _videoCollectionStyles.styles.moreLinkHeader) + ' more-link_vc', href: collection.moreLink },
							collection.moreLabel
						)
					),
					_react2.default.createElement(ContainerTag, { posts: collection.posts, containerStyle: _videoCollectionStyles.styles.container, utmObj: utmObj }),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(_videoCollectionStyles.styles.footer) + ' footer_vc' },
						_react2.default.createElement(
							'a',
							{ className: (0, _noImportant.css)(_videoCollectionStyles.styles.moreLink, _videoCollectionStyles.styles.moreLinkFooter) + ' more-link_vc', href: collection.moreLink },
							collection.moreLabel
						)
					)
				);
			}
		}]);
	
		return VideoCollection;
	}(_react2.default.Component);
	
	exports.default = VideoCollection;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettings = {
		desktop: { item: { width: '360px' } },
		laptop: { item: { width: '300px' } },
		tablet: { item: { width: '223px' } },
		mobile: {
			item: { width: '46%' },
			firstItem: {
				width: '100%'
			},
			firstItemMeta: {
				marginLeft: '10px',
				marginRight: '10px'
			}
		}
	};
	
	var ThreeItems = function (_React$Component) {
		_inherits(ThreeItems, _React$Component);
	
		function ThreeItems(props) {
			_classCallCheck(this, ThreeItems);
	
			return _possibleConstructorReturn(this, (ThreeItems.__proto__ || Object.getPrototypeOf(ThreeItems)).call(this, props));
		}
	
		_createClass(ThreeItems, [{
			key: 'render',
			value: function render() {
				var posts = this.props.posts.slice(0, 3);
				var idx = 0;
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var isShow = this.props.show ? this.props.show : false;
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					posts.map(function (p) {
						return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, isShow: isShow, mediaSettings: cssMediaItemSettings, outerIndex: outerIndex++, innerIndex: idx++, utmObj: utmObj, classPostfix: _constants.constants.VC_CLASS_POSTFIX });
					})
				);
			}
		}]);
	
		return ThreeItems;
	}(_react2.default.Component);
	
	exports.default = ThreeItems;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var constants = exports.constants = {
		VC_CLASS_POSTFIX: 'vc'
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettings = {
		desktop: { item: { width: '260px' } },
		laptop: { item: { width: '223px' } },
		tablet: { item: { width: '347px' } },
		mobile: { item: { width: '46%' } }
	};
	
	var FourItems = function (_React$Component) {
		_inherits(FourItems, _React$Component);
	
		function FourItems(props) {
			_classCallCheck(this, FourItems);
	
			return _possibleConstructorReturn(this, (FourItems.__proto__ || Object.getPrototypeOf(FourItems)).call(this, props));
		}
	
		_createClass(FourItems, [{
			key: 'render',
			value: function render() {
				var posts = this.props.posts.slice(0, 4);
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					posts.map(function (p) {
						return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettings, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants.constants.VC_CLASS_POSTFIX });
					})
				);
			}
		}]);
	
		return FourItems;
	}(_react2.default.Component);
	
	exports.default = FourItems;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _leftContainer, _rightContainer;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(4);
	
	var _constants2 = __webpack_require__(53);
	
	var _constants3 = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettingsLeft = {
		desktop: { item: { width: '100%' } },
		laptop: { item: { width: '100%' } },
		tablet: { item: { width: '100%' } },
		mobile: {
			item: { width: '100%' },
			itemMeta: {
				marginLeft: '10px',
				marginRight: '10px'
			}
		}
	};
	
	var cssMediaItemSettingsRight = {
		desktop: { item: { width: '260px' } },
		laptop: { item: { width: '100%' } },
		tablet: { item: { width: '100%' } },
		mobile: { item: { width: '46%' } }
	};
	
	var FiveItems = function (_React$Component) {
		_inherits(FiveItems, _React$Component);
	
		function FiveItems(props) {
			_classCallCheck(this, FiveItems);
	
			var _this = _possibleConstructorReturn(this, (FiveItems.__proto__ || Object.getPrototypeOf(FiveItems)).call(this, props));
	
			_this.state = {
				leftContainerPosts: _this.props.posts.slice(0, 1),
				rightContainerPosts: _this.props.posts.slice(1, 5),
				currentWidthRange: _constants.widthRange.DESKTOP_MOBILE
			};
			return _this;
		}
	
		_createClass(FiveItems, [{
			key: 'organizeContainers',
			value: function organizeContainers() {
				var _this2 = this;
	
				if (!window) {
					return;
				}
	
				var width = window.innerWidth;
	
				if (width >= 1280 || width <= 767) {
					if (this.state.currentWidthRange === _constants.widthRange.DESKTOP_MOBILE) {
						return;
					}
	
					this.setState(function () {
						return {
							leftContainerPosts: _this2.props.posts.slice(0, 1),
							rightContainerPosts: _this2.props.posts.slice(1, 5),
							currentWidthRange: _constants.widthRange.DESKTOP_MOBILE
						};
					});
	
					return;
				}
	
				if (this.state.currentWidthRange === _constants.widthRange.tabletLaptop) {
					return;
				}
	
				this.setState(function () {
					return {
						leftContainerPosts: _this2.props.posts.slice(0, 2),
						rightContainerPosts: _this2.props.posts.slice(2, 5),
						currentWidthRange: _constants.widthRange.tabletLaptop
					};
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.organizeContainers();
	
				if (window) {
					window.addEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (window) {
					window.removeEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var leftPosts = this.state.leftContainerPosts;
				var rightPosts = this.state.rightContainerPosts;
				var leftIdx = 0;
				var rightIdx = 0;
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.leftContainer) },
						leftPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsLeft, innerIndex: leftIdx++, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.rightContainer) },
						rightPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsRight, innerIndex: rightIdx++, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					)
				);
			}
		}]);
	
		return FiveItems;
	}(_react2.default.Component);
	
	exports.default = FiveItems;
	
	
	var styles = _noImportant.StyleSheet.create({
		leftContainer: (_leftContainer = {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			width: '560px'
	
		}, _defineProperty(_leftContainer, _constants2.media.LAPTOP, {
			width: '560px'
		}), _defineProperty(_leftContainer, _constants2.media.TABLET, {
			width: '450px'
		}), _defineProperty(_leftContainer, _constants2.media.MOBILE, {
			width: '100%',
			justifyContent: 'space-around'
		}), _leftContainer),
		rightContainer: (_rightContainer = {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			width: '560px'
	
		}, _defineProperty(_rightContainer, _constants2.media.LAPTOP, {
			width: '360px'
		}), _defineProperty(_rightContainer, _constants2.media.TABLET, {
			width: '223px'
		}), _defineProperty(_rightContainer, _constants2.media.MOBILE, {
			width: '100%',
			justifyContent: 'space-around'
		}), _rightContainer)
	});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettings = {
		desktop: { item: { width: '360px' } },
		laptop: { item: { width: '300px' } },
		tablet: { item: { width: '347px' } },
		mobile: { item: { width: '46%' } }
	};
	
	var SixItems = function (_React$Component) {
		_inherits(SixItems, _React$Component);
	
		function SixItems(props) {
			_classCallCheck(this, SixItems);
	
			return _possibleConstructorReturn(this, (SixItems.__proto__ || Object.getPrototypeOf(SixItems)).call(this, props));
		}
	
		_createClass(SixItems, [{
			key: 'render',
			value: function render() {
				var posts = this.props.posts.slice(0, 6);
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					posts.map(function (p) {
						return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettings, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants.constants.VC_CLASS_POSTFIX });
					})
				);
			}
		}]);
	
		return SixItems;
	}(_react2.default.Component);
	
	exports.default = SixItems;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _container;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(4);
	
	var _constants2 = __webpack_require__(53);
	
	var _constants3 = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettingsLeft = {
		desktop: { item: { width: '560px' } },
		laptop: { item: { width: '460px' } },
		tablet: { item: { width: '347px' } },
		mobile: {
			item: { width: '100%' },
			itemMeta: {
				marginLeft: '10px',
				marginRight: '10px'
			}
		}
	};
	
	var cssMediaItemSettingsMiddle = {
		desktop: { item: { width: '560px' } },
		laptop: { item: { width: '460px' } },
		tablet: { item: { width: '347px' } },
		mobile: {
			item: { width: '100%' },
			itemMeta: {
				marginLeft: '10px',
				marginRight: '10px'
			}
		}
	};
	
	var cssMediaItemSettingsRight = {
		desktop: { item: { width: '260px' } },
		laptop: { item: { width: '300px' } },
		tablet: { item: { width: '223px' } },
		mobile: { item: { width: '46%' } }
	};
	
	var SevenItems = function (_React$Component) {
		_inherits(SevenItems, _React$Component);
	
		function SevenItems(props) {
			_classCallCheck(this, SevenItems);
	
			var _this = _possibleConstructorReturn(this, (SevenItems.__proto__ || Object.getPrototypeOf(SevenItems)).call(this, props));
	
			_this.state = {
				leftContainerPosts: _this.props.posts.slice(0, 2),
				middleContainerPosts: _this.props.posts.slice(2, 3),
				rightContainerPosts: _this.props.posts.slice(3, 7),
				currentWidthRange: _constants.widthRange.DESKTOP
			};
			return _this;
		}
	
		_createClass(SevenItems, [{
			key: 'organizeContainers',
			value: function organizeContainers() {
				var _this2 = this;
	
				if (!window) {
					return;
				}
	
				var width = window.innerWidth;
	
				if (width >= 1280) {
					if (this.state.currentWidthRange === _constants.widthRange.DESKTOP) {
						return;
					}
	
					this.setState(function () {
						return {
							leftContainerPosts: _this2.props.posts.slice(0, 2),
							middleContainerPosts: _this2.props.posts.slice(2, 3),
							rightContainerPosts: _this2.props.posts.slice(3, 7),
							currentWidthRange: _constants.widthRange.DESKTOP
						};
					});
	
					return;
				}
	
				if (width >= 768) {
					if (this.state.currentWidthRange === _constants.widthRange.TABLET_LAPTOP) {
						return;
					}
	
					this.setState(function () {
						return {
							leftContainerPosts: _this2.props.posts.slice(0, 4),
							middleContainerPosts: [],
							rightContainerPosts: _this2.props.posts.slice(4, 7),
							currentWidthRange: _constants.widthRange.TABLET_LAPTOP
						};
					});
	
					return;
				}
	
				if (this.state.currentWidthRange === _constants.widthRange.MOBILE) {
					return;
				}
	
				this.setState(function () {
					return {
						leftContainerPosts: _this2.props.posts.slice(0, 1),
						middleContainerPosts: [],
						rightContainerPosts: _this2.props.posts.slice(1, 7),
						currentWidthRange: _constants.widthRange.MOBILE
					};
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.organizeContainers();
	
				if (window) {
					window.addEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (window) {
					window.removeEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var leftPosts = this.state.leftContainerPosts;
				var middlePosts = this.state.middleContainerPosts;
				var rightPosts = this.state.rightContainerPosts;
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.container) },
						leftPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsLeft, outerIndex: outerIndex++, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.container, styles.containerHalfWidth) },
						middlePosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsMiddle, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.container, styles.containerHalfWidth) },
						rightPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsRight, outerIndex: outerIndex++, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					)
				);
			}
		}]);
	
		return SevenItems;
	}(_react2.default.Component);
	
	exports.default = SevenItems;
	
	
	var styles = _noImportant.StyleSheet.create({
		container: (_container = {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			width: '100%'
	
		}, _defineProperty(_container, _constants2.media.LAPTOP, {
			width: '100%'
		}), _defineProperty(_container, _constants2.media.TABLET, {
			width: '100%'
		}), _defineProperty(_container, _constants2.media.MOBILE, {
			width: '100%',
			justifyContent: 'space-around'
		}), _container),
		containerHalfWidth: _defineProperty({}, _constants2.media.DESKTOP, {
			width: '560px'
		})
	});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoItem = __webpack_require__(84);
	
	var _VideoItem2 = _interopRequireDefault(_VideoItem);
	
	var _noImportant = __webpack_require__(15);
	
	var _constants = __webpack_require__(4);
	
	var _constants2 = __webpack_require__(53);
	
	var _constants3 = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cssMediaItemSettingsLeft = {
		desktop: { item: { width: '100%' } },
		laptop: { item: { width: '460px' } },
		tablet: { item: { width: '347px' } },
		mobile: { item: { width: '100%' } }
	};
	
	var cssMediaItemSettingsRight = {
		desktop: { item: { width: '260px' } },
		laptop: { item: { width: '300px' } },
		tablet: { item: { width: '223px' } },
		mobile: { item: { width: '46%' } }
	};
	
	var EightItems = function (_React$Component) {
		_inherits(EightItems, _React$Component);
	
		function EightItems(props) {
			_classCallCheck(this, EightItems);
	
			var _this = _possibleConstructorReturn(this, (EightItems.__proto__ || Object.getPrototypeOf(EightItems)).call(this, props));
	
			_this.state = {
				leftContainerPosts: [],
				rightContainerPosts: _this.props.posts.slice(0, 8),
				currentWidthRange: _constants.widthRange.DESKTOP_MOBILE
			};
			return _this;
		}
	
		_createClass(EightItems, [{
			key: 'organizeContainers',
			value: function organizeContainers() {
				var _this2 = this;
	
				if (!window) {
					return;
				}
	
				var width = window.innerWidth;
	
				if (width >= 1280 || width <= 767) {
					if (this.state.currentWidthRange === _constants.widthRange.DESKTOP_MOBILE) {
						return;
					}
	
					this.setState(function () {
						return {
							leftContainerPosts: [],
							rightContainerPosts: _this2.props.posts,
							currentWidthRange: _constants.widthRange.DESKTOP_MOBILE
						};
					});
	
					return;
				}
	
				if (this.state.currentWidthRange === _constants.widthRange.tabletLaptop) {
					return;
				}
	
				this.setState(function () {
					return {
						leftContainerPosts: _this2.props.posts.slice(0, 2),
						rightContainerPosts: _this2.props.posts.slice(2, 8),
						currentWidthRange: _constants.widthRange.tabletLaptop
					};
				});
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.organizeContainers();
	
				if (window) {
					window.addEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (window) {
					window.removeEventListener("resize", this.organizeContainers.bind(this));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var leftPosts = this.state.leftContainerPosts;
				var rightPosts = this.state.rightContainerPosts;
				var outerIndex = 0;
				var utmObj = this.props.utmObj || {};
				var key = 1;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(this.props.containerStyle) },
					leftPosts.length > 0 && _react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.container) },
						leftPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsLeft, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _noImportant.css)(styles.container) },
						rightPosts.map(function (p) {
							return _react2.default.createElement(_VideoItem2.default, { post: p, key: key++, mediaSettings: cssMediaItemSettingsRight, outerIndex: outerIndex++, utmObj: utmObj, classPostfix: _constants3.constants.VC_CLASS_POSTFIX });
						})
					)
				);
			}
		}]);
	
		return EightItems;
	}(_react2.default.Component);
	
	exports.default = EightItems;
	
	
	var styles = _noImportant.StyleSheet.create({
		container: _defineProperty({
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			width: '100%'
	
		}, _constants2.media.MOBILE, {
			justifyContent: 'space-around'
		})
	});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.styles = undefined;
	
	var _collectionWrapper, _showImageCont, _showLogo;
	
	var _noImportant = __webpack_require__(15);
	
	var _vars = __webpack_require__(52);
	
	var _constants = __webpack_require__(53);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var styles = exports.styles = _noImportant.StyleSheet.create({
		title: _defineProperty({
			fontSize: '18px',
			fontWeight: _vars.fontWeight.normal,
			letterSpacing: '6.5px',
			marginBottom: '26px',
			textTransform: 'uppercase'
	
		}, _constants.media.MOBILE, {
			marginLeft: '10px',
			marginBottom: '17px',
			fontSize: '13px'
		}),
	
		header: {
			width: '100%',
			display: 'inline-flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		},
	
		collectionWrapper: (_collectionWrapper = {
			position: 'relative',
			marginBottom: '20px',
			height: '720px'
	
		}, _defineProperty(_collectionWrapper, _constants.media.TABLET, {
			height: '620px'
		}), _defineProperty(_collectionWrapper, _constants.media.MOBILE, {
			height: '461px'
		}), _collectionWrapper),
	
		footer: _defineProperty({
			width: '100%',
			display: 'inline-flex',
			justifyContent: 'center',
			alignItems: 'center'
	
		}, _constants.media.MOBILE, {
			marginBottom: '25px'
		}),
	
		moreLink: {
			fontSize: '12px',
			fontWeight: _vars.fontWeight.bold,
			color: _vars.color.blue,
			textDecoration: 'none',
	
			':hover': {
				color: _vars.color.darkBlue
			}
		},
	
		moreLinkHeader: _defineProperty({}, _constants.media.MOBILE, {
			display: 'none'
		}),
	
		moreLinkFooter: _defineProperty({}, _constants.media.AT_LEAST_TABLET, {
			display: 'none'
		}),
	
		container: _defineProperty({
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			marginBottom: '20px',
			alignItems: 'flex-start'
	
		}, _constants.media.MOBILE, {
			justifyContent: 'space-around',
			marginBottom: '0'
		}),
	
		vcWrapper: _defineProperty({}, _constants.media.MOBILE, {
			width: '100%',
			overflowX: 'auto',
			height: 'auto',
			'-webkit-overflow-scrolling': 'touch'
		}),
	
		containerVC: _defineProperty({
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			marginBottom: '20px',
			alignItems: 'flex-start'
	
		}, _constants.media.MOBILE, {
			justifyContent: 'space-between',
			marginBottom: '0',
			height: 'auto',
			overflowX: 'auto',
			display: 'inline-flex',
			padding: '0 5px',
			flexWrap: 'nowrap',
			alignItems: 'normal'
		}),
	
		showContainer: {
			width: '100%',
			height: '100%'
		},
	
		showDetails: _defineProperty({}, _constants.media.MOBILE, {
			padding: '0 10px'
		}),
	
		showImageCont: (_showImageCont = {
			width: '1280px',
			position: 'absolute',
			zIndex: '-1',
			marginLeft: '-50px',
			backgroundColor: _vars.color.black
	
		}, _defineProperty(_showImageCont, _constants.media.LAPTOP, {
			width: '100vw',
			height: '700px',
			marginLeft: 'calc(-50vw + 50%)'
		}), _defineProperty(_showImageCont, _constants.media.TABLET, {
			width: '100vw',
			height: '100%',
			marginLeft: 'calc(-50vw + 50%)'
		}), _defineProperty(_showImageCont, _constants.media.MOBILE, {
			width: '100%',
			marginLeft: '0px',
			height: '80%'
		}), _showImageCont),
	
		imageWrapper: {
			position: 'relative'
		},
	
		showOverlay: _defineProperty({
			position: 'absolute',
			width: '100%',
			height: '60%',
			top: '40%',
			backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.0), #000000)'
	
		}, _constants.media.MOBILE, {
			width: '100%'
		}),
	
		showImage: _defineProperty({
			width: '100%',
			display: 'block',
	
			':after': {
				backgroundImage: 'linear-gradient(to bottom, transparent 0%, white 100%)'
			}
	
		}, _constants.media.MOBILE, {
			width: '100%',
			height: 'auto'
		}),
	
		showVCContainer: {
			position: 'relative',
			height: '100%',
			paddingTop: '30px'
		},
	
		divider: _defineProperty({
			height: '1px',
			opacity: '0.2',
			backgroundColor: '#ffffff',
			display: 'block',
			marginBottom: '30px'
	
		}, _constants.media.MOBILE, {
			marginBottom: '20px'
		}),
	
		showLogo: (_showLogo = {
			width: '250px',
			marginBottom: '22px'
	
		}, _defineProperty(_showLogo, _constants.media.TABLET, {
			width: '210px'
		}), _defineProperty(_showLogo, _constants.media.MOBILE, {
			width: '120px',
			marginBottom: '13px'
		}), _showLogo),
	
		showLogoImg: {
			width: '100%',
			height: '100%'
		},
	
		logoLink: {
			display: 'block',
			width: '100%',
			height: '100%'
		},
	
		airTime: _defineProperty({
			display: 'block',
			fontSize: '17px',
			fontWeight: 'bold',
			lineHeight: '0.94',
			textAlign: 'left',
			color: '#ffffff',
			marginBottom: '40px'
	
		}, _constants.media.MOBILE, {
			fontSize: '11px',
			lineHeight: '1.45',
			marginBottom: '17px'
		}),
	
		moreBtnBg: _defineProperty({
			height: '40px',
			borderRadius: '4px',
			backgroundColor: _vars.color.white,
			display: 'inline-flex',
			textDecoration: 'none',
			marginBottom: '50px'
	
		}, _constants.media.MOBILE, {
			marginBottom: '20px'
		}),
	
		moreBtnText: {
			fontSize: '12px',
			fontWeight: 'bold',
			textAlign: 'left',
			color: '#000000',
			margin: 'auto 20px',
			textDecoration: 'none',
			cursor: 'inherit'
	
		}
	
	});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(15);
	
	var _ThreeItems = __webpack_require__(97);
	
	var _ThreeItems2 = _interopRequireDefault(_ThreeItems);
	
	var _videoCollectionStyles = __webpack_require__(104);
	
	var _utils = __webpack_require__(8);
	
	var _VideoCollectionsService = __webpack_require__(95);
	
	var _VideoCollectionsService2 = _interopRequireDefault(_VideoCollectionsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoShowCollection = function (_React$Component) {
	    _inherits(VideoShowCollection, _React$Component);
	
	    function VideoShowCollection(props) {
	        _classCallCheck(this, VideoShowCollection);
	
	        var _this = _possibleConstructorReturn(this, (VideoShowCollection.__proto__ || Object.getPrototypeOf(VideoShowCollection)).call(this, props));
	
	        _this.state = {
	            collection: props.collection
	        };
	        return _this;
	    }
	
	    _createClass(VideoShowCollection, [{
	        key: 'render',
	        value: function render() {
	            var collection = this.state.collection;
	            var ContainerTag = _ThreeItems2.default;
	            var logoImgTag = (0, _utils.parseImagesTag)(collection.logoImage);
	            var bgImgTag = (0, _utils.parseImagesTag)(collection.bgImage);
	            var utmObj = _VideoCollectionsService2.default.setCollectionUTM(collection, this.props.index);
	
	            return _react2.default.createElement(
	                'div',
	                { id: this.props.id, className: (0, _noImportant.css)(_videoCollectionStyles.styles.collectionWrapper) },
	                _react2.default.createElement(
	                    'div',
	                    { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showContainer) },
	                    _react2.default.createElement('input', { type: 'hidden', value: collection.posts.length, className: 'collection-size_vc' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showImageCont) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _noImportant.css)(_videoCollectionStyles.styles.imageWrapper) },
	                            _react2.default.createElement('div', { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showOverlay) }),
	                            _react2.default.createElement('img', { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showImage) + ' lazyload', 'data-src': bgImgTag.src, 'data-srcset': bgImgTag.srcSet, 'data-sizes': bgImgTag.sizes }),
	                            bgImgTag.noscript && _react2.default.createElement(
	                                'noscript',
	                                null,
	                                bgImgTag.noscript
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showVCContainer) },
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showDetails) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showLogo) },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: collection.moreLink, className: (0, _noImportant.css)(_videoCollectionStyles.styles.logoLink) },
	                                    _react2.default.createElement('img', { className: (0, _noImportant.css)(_videoCollectionStyles.styles.showLogoImg) + ' lazyload', 'data-src': logoImgTag.src, 'data-srcset': logoImgTag.srcSet, 'data-sizes': logoImgTag.sizes }),
	                                    logoImgTag.noscript && _react2.default.createElement(
	                                        'noscript',
	                                        null,
	                                        logoImgTag.noscript
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { className: (0, _noImportant.css)(_videoCollectionStyles.styles.airTime) },
	                                ' ',
	                                collection.airTime,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: collection.moreLink, className: (0, _noImportant.css)(_videoCollectionStyles.styles.moreBtnBg) },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: (0, _noImportant.css)(_videoCollectionStyles.styles.moreBtnText) },
	                                    ' ',
	                                    collection.moreLabel,
	                                    ' '
	                                )
	                            ),
	                            _react2.default.createElement('span', { className: (0, _noImportant.css)(_videoCollectionStyles.styles.divider) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _noImportant.css)(_videoCollectionStyles.styles.vcWrapper) },
	                            _react2.default.createElement(ContainerTag, { posts: collection.posts, show: true, containerStyle: _videoCollectionStyles.styles.containerVC, utmObj: utmObj })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return VideoShowCollection;
	}(_react2.default.Component);
	
	exports.default = VideoShowCollection;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/dist/js/react/video-collections.min.js